import React, { useState, useEffect } from "react"
import MetaTags from "react-meta-tags" // Added Meta Tag npm Package
import {
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  CardText,
  Form,
  Container,
  Button,
  Alert,
  Modal,
  UncontrolledDropdown,
  UncontrolledTooltip,
  DropdownToggle,
  DropdownMenu,
  Table,
} from "reactstrap"

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb"

import { useHistory } from "react-router-dom"
import "flatpickr/dist/themes/material_blue.css"
import Flatpickr from "react-flatpickr"

import axios from "axios"
import {
  HRConfig,
  TOAST_OPTIONS1,
  formatDate,
  downloadBase64File,
  getContentTypeFromBase64,
  TOAST_OPTIONS3,
} from "../../helpers/backend_helper"
import * as url from "helpers/url_helper"

import toastr from "toastr"
import "toastr/build/toastr.min.css"
import Select from "react-select"
import Swal from "sweetalert2"

import LoadingOverlay from "react-loading-overlay"
import ClimbingBoxLoader from "react-spinners/ClimbingBoxLoader"
import { useParams } from "react-router-dom"
import { Link } from "react-router-dom"
import { classname } from "classnames"

const PaymentRequisitionDetails = () => {
  const history = useHistory()
  const { id } = useParams()

  const [inputs, setInputs] = useState([])
  const [empTitle, setEmpTitle] = useState("")
  const [requisitionerNo, setRequisitionerNo] = useState("")
  const [employeeNo1, setEmployeeNo1] = useState("")

  const [payeeOptions, setPayeeOptions] = useState([])
  const [currencyList, setCurrencyList] = useState([])
  const [accType, setAccType] = useState([
    "G/L Account",
    "Vendor",
    "Customer",
    "Bank Account",
  ])

  const [selectedPayee, setSelectedPayee] = useState("")
  const [paymentCategory, setPaymentCategory] = useState("")
  const [paymentSubCategory, setPaymentSubCategory] = useState("")
  const [purpose, setPurpose] = useState("")
  const [cancellationcomment, setCancellationComment] = useState("")
  const [currencyCode, setCurrencyCode] = useState("")
  const [projectCode, setProjectCode] = useState("")
  const [payeeNo, setPayeeNo] = useState("")
  const [payeeName, setPayeeName] = useState("")
  const [amount, setAmount] = useState("")
  const [amountLCY, setAmountLCY] = useState("")
  const [no, setNo] = useState("")
  const [status, setStatus] = useState("")

  const [etag, setEtag] = useState("")
  const [systemId, setSystemId] = useState("")

  const [selectedType, setSelectedType] = useState("")

  const [paymentRequisitionLines, setPaymentRequisitionLines] = useState([])
  const [approvalCommentLines, setApprovalCommentLines] = useState([])

  const [noo, setNoo] = useState([])
  const [noo1, setNoo1] = useState([])

  const [isloading, setIsloading] = useState(false)
  const [userError, setUserError] = useState(true)
  const [ipaSaved, setIpaSaved] = useState(false)
  const [ipaNo, setIpaNo] = useState("")

  const [showPayeeNo, setShowPayeeNo] = useState(false)

  const [modal_line, setmodal_line] = useState(false)
  const [modal_comments, setmodal_comments] = useState(false)
  const [modal_applyEntries, setmodal_applyEntries] = useState(false)
  const [isEdit, setIsEdit] = useState(false)
  const [editLine, setEditLine] = useState(false)
  const [addDetails, setAddDetails] = useState(false)
  const [managementActivities, setManagementActivities] = useState([])

  const [rNo, setRNo] = useState("")
  const [departmentcode, setDepartmentCode] = useState("")
  const [RStatus, setRStatus] = useState("")
  const [empNo, setEmpNo] = useState("")
  const [empName, setEmpName] = useState("")
  const [CompanyID, setCompanyID] = useState("")

  const [payeeType, setPayeeType] = useState("")
  const [selectedNo, setSelectedNo] = useState("")
  const [selectedNo2, setSelectedNo2] = useState("")
  const [workplanno, setWorkPlanNo] = useState("")
  const [workplans, setWorkPlans] = useState([])
  const [transactionTypeslist, setTransactionTypesList] = useState([])
  const [externalDocumentNo, setExternalDocumentNo] = useState("")
  const [activityStartDate, setActivityStartDate] = useState("")
  const [activityEndDate, setActivityEndDate] = useState("")

  const [accountType, setAccountType] = useState("")
  const [accountNo, setAccountNo] = useState("")
  const [accountName, setAccountName] = useState("")
  const [customers, setCustomers] = useState([])
  const [wkPlanGLAccounts, setWorkPlanGLAccounts] = useState([])
  const [nonwkPlanGLAccounts, setNonWorkPlanGLAccounts] = useState([])
  const [bankAccounts, setBankAccounts] = useState([])
  const [workPlanEntry, setWorkPlanEntry] = useState([])
  const [fundsourceDim, setFundSourceDim] = useState([])
  const [narration, setNarration] = useState("")
  const [rate, setRate] = useState(0)
  const [quantity, setQuantity] = useState("")
  const [workPlanEntryNo, setWorkPlanEntryNo] = useState("")
  const [whtpercentage, setWHTPercentage] = useState("")
  const [whtamount, setWHTAmount] = useState("")
  const [lineSystemId, setLineSystemId] = useState("")
  const [whtAmountOnVAT, setWHTAmountonVAT] = useState("")
  const [vatAmount, setVATAmount] = useState("")
  const [amountToPay, setAmounttoPay] = useState("")
  const [amountPaid, setAmountPaid] = useState("")
  const [noOfInstallments, setNoofInstallments] = useState("")
  const [installmentAmount, setInstallmentAmount] = useState("")
  const [fundsource, setFundSource] = useState("")

  const [applnID, setApplnID] = useState("")
  const [applyEntry, setApplyEntry] = useState(false)
  const [applnPostingDate, setApplnPostingDate] = useState("")
  const [applnDocumentType, setApplnDocumentType] = useState("")
  const [applnDocumentNo, setApplnDocumentNo] = useState("")
  const [applnExtDocNo, setApplnExtDocNo] = useState("")
  const [applnDescription, setApplnDescription] = useState("")
  const [applnCurrencyCode, setApplnCurrencyCode] = useState("")
  const [remainingAmount, setRemainingAmount] = useState("")
  const [applnReminingAmount, setApplnRemainingAmount] = useState("")

  const [loadingFiles, setLoadingFiles] = useState(false)
  const [selectedFile, setSelectedFile] = useState([])
  const [uploadedFiles, setUploadedFiles] = useState([])
  const [modal_attachments, setmodal_attachments] = useState(false)

  const removeBodyCss = () => {
    document.body.classList.add("no_padding")
  }
  const tog_line = () => {
    setmodal_line(!modal_line)
    removeBodyCss()
  }
  const tog_comments = () => {
    setmodal_comments(!modal_comments)
    removeBodyCss()
  }
  const tog_applyEntries = () => {
    console.log(payeeNo)
    axios
      .get(
        `${url.VENDORLEDGERENTRIES}?$filter=vendorNo eq '${payeeNo}' &company='${CompanyID}'`,
        HRConfig
      )
      .then(r => {
        setManagementActivities(r.data.value)
      })
      .catch(e => {
        console.log(e)
      })
    setmodal_applyEntries(!modal_applyEntries)
    removeBodyCss()
  }
  const tog_history = () => {
    setmodal_history(!modal_history)
    removeBodyCss()
  }
  const tog_attachments = () => {
    setmodal_attachments(!modal_attachments)
    removeBodyCss()
  }

  toastr.options = TOAST_OPTIONS3

  const updateApplyEntry = e => {
    let newAEntry = e.target.value
    console.log(newAEntry)
    console.log(e.target.value)
    if (e.target.value != "") {
      let req = {}
      req = {
        applyEntry: newAEntry,
      }
      toastr.info("Saving...")
      const Config = {
        auth: {
          username: url.HRMIS,
          password: url.HRMISPASS,
        },
        headers: {
          "Content-Type": "application/json",
          "If-Match": "*",
        },
      }
      axios
        .patch(
          `${url.VENDORLEDGERENTRIES}(${applnID})?company=${CompanyID}`,
          JSON.stringify(req),
          Config
        )
        .then(function (response) {
          if (response.status == "200") {
            toastr.success("Saved")
            setApplyEntry(newAEntry)
            axios
              .get(
                `${url.VENDORLEDGERENTRIES}?$filter=vendorNo eq '${payeeNo}' &company='${CompanyID}'`,
                HRConfig
              )
              .then(r => {
                setManagementActivities(r.data.value)
              })
              .catch(er => {})
          } else {
            toastr.error("Could not update Apply Entry Status")
          }
          setIsloading(false)
        })
        .catch(function (error) {
          toastr.error(error.response.data.error.message)
          setIsloading(false)
        })
    }
  }

  const updateexternalDocumentNo = e => {
    if (e.target.value != "") {
      let req = {}
      req = {
        externalDocumentNo: e.target.value,
      }
      toastr.info("Saving...")
      const Config = {
        auth: {
          username: url.HRMIS,
          password: url.HRMISPASS,
        },
        headers: {
          "Content-Type": "application/json",
          "If-Match": "*",
        },
      }
      axios
        .patch(
          `${url.PAYMENTS1}(${id})?company=${CompanyID}`,
          JSON.stringify(req),
          Config
        )
        .then(function (response) {
          if (response.status == "200") {
            toastr.success("Saved")
          } else {
            toastr.error("Could not save External Document Number")
          }
          setIsloading(false)
        })
        .catch(function (error) {
          toastr.error(error.response.data.error.message)
          setIsloading(false)
        })
    }
  }
  const handleUnapplyEntries = e => {
    if (managementActivities.length > 0) {
      Swal.fire({
        title: "Are you sure?",
        text: "This will unapply all un-selected vendor ledger entry lines.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#019654",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, Proceed!",
        cancelButtonText: "Cancel",
      }).then(result => {
        if (result.isConfirmed) {
          let req = {}
          req = {
            no: rNo,
          }
          toastr.info("Saving...")
          const Config = {
            auth: {
              username: url.HRMIS,
              password: url.HRMISPASS,
            },
            headers: {
              "Content-Type": "application/json",
              "If-Match": "*",
            },
          }
          axios
            .post(
              url.UNAPPLYENTRIES + "?company=" + CompanyID,
              JSON.stringify(req),
              HRConfig
            )
            .then(function (response) {
              if (response.status == "200") {
                axios
                  .get(
                    `${url.VENDORLEDGERENTRIES}?$filter=vendorNo eq '${payeeNo}' &company='${CompanyID}'`,
                    HRConfig
                  )
                  .then(r => {
                    setManagementActivities(r.data.value)
                    toastr.success("Unapplied entries successfully!")
                    getData()
                  })
                  .catch(er => {})
              } else {
                toastr.error("Could not unapply Entries")
              }
              setIsloading(false)
            })
            .catch(function (error) {
              toastr.error(error.response.data.error.message)
              setIsloading(false)
            })
        }
      })
    }
  }

  const handleAppliestoID = e => {
    if (managementActivities.length > 0) {
      Swal.fire({
        title: "Are you sure?",
        text: "This will set the Applies to Document Number on all selected vendor ledger entry lines.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#019654",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, Proceed!",
        cancelButtonText: "Cancel",
      }).then(result => {
        if (result.isConfirmed) {
          let req = {}
          req = {
            no: rNo,
          }
          toastr.info("Saving...")
          const Config = {
            auth: {
              username: url.HRMIS,
              password: url.HRMISPASS,
            },
            headers: {
              "Content-Type": "application/json",
              "If-Match": "*",
            },
          }
          axios
            .post(
              url.SETAPPLIESTOID + "?company=" + CompanyID,
              JSON.stringify(req),
              HRConfig
            )
            .then(function (response) {
              if (response.status == "200") {
                axios
                  .get(
                    `${url.VENDORLEDGERENTRIES}?$filter=vendorNo eq '${payeeNo}' &company='${CompanyID}'`,
                    HRConfig
                  )
                  .then(r => {
                    setManagementActivities(r.data.value)
                    toastr.success("Saved")
                    getData()
                  })
                  .catch(er => {})
              } else {
                toastr.error("Could not set Applies-to ID!")
              }
              setIsloading(false)
            })
            .catch(function (error) {
              toastr.error(error.response.data.error.message)
              setIsloading(false)
            })
        }
      })
    }
  }

  const updatePurpose = e => {
    if (e.target.value != "") {
      let req = {}
      req = {
        purpose: e.target.value,
      }
      toastr.info("Saving...")
      const Config = {
        auth: {
          username: url.HRMIS,
          password: url.HRMISPASS,
        },
        headers: {
          "Content-Type": "application/json",
          "If-Match": "*",
        },
      }
      axios
        .patch(
          `${url.PAYMENTS1}(${id})?company=${CompanyID}`,
          JSON.stringify(req),
          Config
        )
        .then(function (response) {
          if (response.status == "200") {
            toastr.success("Saved")
          } else {
            toastr.error("Could not save Purpose!")
          }
          setIsloading(false)
        })
        .catch(function (error) {
          toastr.error(error.response.data.error.message)
          setIsloading(false)
        })
    }
  }

  const handleAccountTypeChange = e => {
    if (e.target.value == accountType) {
      console.log(accountType)
    } else if (e.target.value == "")
      toastr.error("Account type must not be blank!")
    setIsloading(true)
    let newAType = e.target.value
    let req = {}
    req = {
      documentNo: rNo,
      accountType: e.target.value,
      accountNo: payeeNo,
    }
    toastr.info("Saving...")
    const Config = {
      auth: {
        username: url.HRMIS,
        password: url.HRMISPASS,
      },
      headers: {
        "Content-Type": "application/json",
        "If-Match": "*",
      },
    }
    axios
      .post(
        `${url.PMTREQNLINES}?company=${CompanyID}`,
        JSON.stringify(req),
        Config
      )
      .then(function (response) {
        if (response.status == "201") {
          toastr.success("Saved")
          setAccountType(newAType)
          setAccountNo(response.data.accountNo)
          setAccountName(response.data.accountName)
          getData()
        } else {
          toastr.error("Could not save payment requisition line!")
        }
        setIsloading(false)
      })
      .catch(function (error) {
        toastr.error(error.response.data.error.message)
        setIsloading(false)
      })
  }

  const handleAccountTypeChange2 = e => {
    let newTType = e.target.value
    if (isEdit) {
      Swal.fire({
        title: "Are you sure?",
        text: "Modifying the Account type will delete the payment requisition line. This action is irreversible. Do you wish to proceed?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#019654",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, Proceed!",
      }).then(result => {
        if (result.isConfirmed) {
          const Config = {
            auth: {
              username: url.HRMIS,
              password: url.HRMISPASS,
            },
            headers: {
              "Content-Type": "application/json",
              "If-Match": "*",
            },
          }
          axios
            .delete(
              `${url.PMTREQNLINES}(${lineSystemId})?company=${CompanyID}`,
              Config
            )
            .then(response => {
              setIsloading(false)
              setSelectedNo(newTType)
              preparePayeeNo(payeeType)
              tog_line(false)
              getData()
            })
        }
      })
    }
    if (!isEdit) {
      setIsloading(true)
      setAccountType(e.target.value)
      fetchWorkplanGLAccounts()
    }
  }

  const handleAccountTypeChange3 = e => {
    let newTType = e.target.value
    if (isEdit) {
      Swal.fire({
        title: "Are you sure?",
        text: "Modifying the Account type will delete the payment requisition line. This action is irreversible. Do you wish to proceed?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#019654",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, Proceed!",
      }).then(result => {
        if (result.isConfirmed) {
          const Config = {
            auth: {
              username: url.HRMIS,
              password: url.HRMISPASS,
            },
            headers: {
              "Content-Type": "application/json",
              "If-Match": "*",
            },
          }
          axios
            .delete(
              `${url.PMTREQNLINES}(${lineSystemId})?company=${CompanyID}`,
              Config
            )
            .then(response => {
              setIsloading(false)
              setSelectedNo(newTType)
              preparePayeeNo(payeeType)
              tog_line(false)
              getData()
            })
        }
      })
    }
    if (!isEdit) {
      setIsloading(true)
      setAccountType(e.target.value)
      fetchNonWorkplanGLAccounts()
    }
  }

  const handleAccountTypeChange5 = e => {
    let newTType = e.target.value
    if (isEdit) {
      Swal.fire({
        title: "Are you sure?",
        text: "Modifying the Account type will delete the payment requisition line. This action is irreversible. Do you wish to proceed?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#019654",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, Proceed!",
      }).then(result => {
        if (result.isConfirmed) {
          const Config = {
            auth: {
              username: url.HRMIS,
              password: url.HRMISPASS,
            },
            headers: {
              "Content-Type": "application/json",
              "If-Match": "*",
            },
          }
          axios
            .delete(
              `${url.PMTREQNLINES}(${lineSystemId})?company=${CompanyID}`,
              Config
            )
            .then(response => {
              setIsloading(false)
              setSelectedNo(newTType)
              preparePayeeNo(payeeType)
              tog_line(false)
              getData()
            })
        }
      })
    }
    if (!isEdit) {
      setIsloading(true)
      setAccountType(e.target.value)
      setAccountNo(selectedNo2)
      fetchBankAccounts()
    }
  }

  const handleAccountTypeChange4 = e => {
    let newTType = e.target.value
    if (isEdit) {
      Swal.fire({
        title: "Are you sure?",
        text: "Modifying the Account type will delete the payment requisition line. This action is irreversible. Do you wish to proceed?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#019654",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, Proceed!",
      }).then(result => {
        if (result.isConfirmed) {
          const Config = {
            auth: {
              username: url.HRMIS,
              password: url.HRMISPASS,
            },
            headers: {
              "Content-Type": "application/json",
              "If-Match": "*",
            },
          }
          axios
            .delete(
              `${url.PMTREQNLINES}(${lineSystemId})?company=${CompanyID}`,
              Config
            )
            .then(response => {
              setIsloading(false)
              setSelectedNo(newTType)
              preparePayeeNo(payeeType)
              tog_line(false)
              getData()
            })
        }
      })
    }
    if (!isEdit) {
      setAccountType(e.target.value)
      if (e.target.value == "Customer") {
        fetchCustomers2()
      }
      if (e.target.value == "G/L Account") {
        fetchWorkplanGLAccounts()
      }
      if (e.target.value == "None Workplan- G/L") {
        fetchNonWorkplanGLAccounts()
      }
      if (e.target.value == "Bank Account") {
        fetchBankAccounts()
      }
    }
  }

  const fetchCustomers2 = async () => {
    axios
      .get(
        `${url.CUSTOMERS}?$filter=no eq '${selectedNo2}' &company=${CompanyID}`,
        HRConfig
      )
      .then(r => {
        let options = []
        r.data.value.map(a => {
          options.push({ value: a.no, label: `${a.no} ${": "} ${a.name}` })
        })
        setNoo(options)
        setCustomers(options)
        if (customers.length > 0) {
          setIsloading(false)
        }
        setIsloading(false)
      })
      .catch(e => {
        console.log(e)
        setIsloading(false)
      })
  }

  const fetchWorkplanGLAccounts = async () => {
    axios
      .get(
        `${url.WORKPLANGLACCOUNTS}?$filter=workPlanNo eq '${workplanno}' &company=${CompanyID}`,
        HRConfig
      )
      .then(r => {
        let options = []
        r.data.value.map(a => {
          options.push({
            value: a.gLAcccount,
            label: `${a.no} ${": "} ${a.accountName}`,
          })
        })
        setNoo(options)
        setWorkPlanGLAccounts(options)
        if (wkPlanGLAccounts.length > 0) {
          setIsloading(false)
        }
        setIsloading(false)
      })
      .catch(e => {
        console.log(e)
        setIsloading(false)
      })
  }

  const fetchBankAccounts = async () => {
    axios
      .get(url.BANKACCOUNTS + "?company=" + CompanyID, HRConfig)
      .then(r => {
        let options = []
        r.data.value.map(a => {
          options.push({ value: a.no, label: `${a.no} ${": "} ${a.name}` })
        })
        setNoo(options)
        setBankAccounts(options)
        if (bankAccounts.length > 0) {
          setIsloading(false)
        }
        setIsloading(false)
      })
      .catch(e => {
        console.log(e)
        setIsloading(false)
      })
  }

  const fetchNonWorkplanGLAccounts = async () => {
    axios
      .get(
        `${url.GLACCOUNTS}?$filter=directPosting eq true and nonWorkPlanEntry eq true &company=${CompanyID}`,
        HRConfig
      )
      .then(r => {
        let options = []
        r.data.value.map(a => {
          options.push({ value: a.no, label: `${a.no} ${": "} ${a.name}` })
        })
        setNoo(options)
        setNonWorkPlanGLAccounts(options)
        if (nonwkPlanGLAccounts.length > 0) {
          setIsloading(false)
        }
        setIsloading(false)
      })
      .catch(e => {
        console.log(e)
        setIsloading(false)
      })
  }

  const updatecurrencyCode = e => {
    let newCCode = e.target.value
    let req = {}
    req = {
      currencyCode: e.target.value,
    }
    toastr.info("Saving...")
    const Config = {
      auth: {
        username: url.HRMIS,
        password: url.HRMISPASS,
      },
      headers: {
        "Content-Type": "application/json",
        "If-Match": "*",
      },
    }
    axios
      .patch(
        `${url.PAYMENTS1}(${id})?company=${CompanyID}`,
        JSON.stringify(req),
        Config
      )
      .then(function (response) {
        if (response.status == "200") {
          toastr.success("Saved")
          setCurrencyCode(newCCode)
        } else {
          toastr.error("Could not save currency code!")
        }
        setIsloading(false)
      })
      .catch(function (error) {
        toastr.error(error.response.data.error.message)
        setIsloading(false)
      })
  }

  const updateTransactionType = e => {
    let newTType = e.target.value
    if (
      selectedNo != "" &&
      e.target.value != selectedNo &&
      paymentRequisitionLines.length > 0
    ) {
      Swal.fire({
        title: "Are you sure?",
        text: "Modifying the transaction type will delete all associated payment requisition lines. This action is irreversible. Do you wish to proceed?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#019654",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, Proceed!",
      }).then(result => {
        if (result.isConfirmed) {
          setIsloading(true)
          const Config = {
            auth: {
              username: url.HRMIS,
              password: url.HRMISPASS,
            },
            headers: {
              "Content-Type": "application/json",
              "If-Match": "*",
            },
          }
          axios
            .get(
              `${url.PMTREQNLINES}?$filter=documentNo eq '${rNo}' &company=${CompanyID}`,
              Config
            )
            .then(res => {
              let resObj = res.data.value
              resObj.forEach((obj, index) => {
                const Config = {
                  auth: {
                    username: url.HRMIS,
                    password: url.HRMISPASS,
                  },
                  headers: {
                    "Content-Type": "application/json",
                    "If-Match": "*",
                  },
                }
                let req = {}
                req = {
                  transactionType: newTType,
                  payeeNo: "",
                  payeeName: "",
                  workPlanNo: "",
                }

                axios
                  .delete(
                    `${url.PMTREQNLINES}(${obj.id})?company=${CompanyID}`,
                    Config
                  )
                  .then(response => {
                    setIsloading(false)
                    setSelectedNo(newTType)
                    preparePayeeNo(payeeType)

                    axios
                      .patch(
                        `${url.PAYMENTS1}(${id})?company=${CompanyID}`,
                        JSON.stringify(req),
                        Config
                      )
                      .then(function (response) {
                        if (response.status == "200") {
                          toastr.success("Saved")
                          setSelectedNo(newTType)
                          history.go("0")
                        } else {
                          toastr.error("Could not save Payee type")
                        }
                        setIsloading(false)
                        preparePayeeNo(payeeType)
                        history.go("0")
                      })
                      .catch(function (error) {
                        toastr.error(error.response.data.error.message)
                        setIsloading(false)
                      })
                  })
                  .catch(function (error) {
                    toastr.error(error.response.data.error.message)
                    setIsloading(false)
                  })
              })

              if (resObj.length == 0) {
                toastr.info(
                  "Payment requisition Lines have been cleared. You can now create new lines."
                )
                setIsloading(false)
                setSelectedNo(newTType)
                preparePayeeNo(payeeType)
              }
            })
            .catch(function (error) {
              toastr.error(error.response.data.error.message)
              setIsloading(false)
            })
        }
      })
    }

    if (paymentRequisitionLines.length == 0) {
      let req = {}
      req = {
        transactionType: e.target.value,
        payeeNo: "",
        payeeName: "",
        workPlanNo: "",
        // budgetCode          : '',
        // shortcutDim1Value   : ''
      }
      toastr.info("Saving...")
      const Config = {
        auth: {
          username: url.HRMIS,
          password: url.HRMISPASS,
        },
        headers: {
          "Content-Type": "application/json",
          "If-Match": "*",
        },
      }
      axios
        .patch(
          `${url.PAYMENTS1}(${id})?company=${CompanyID}`,
          JSON.stringify(req),
          Config
        )
        .then(function (response) {
          if (response.status == "200") {
            toastr.success("Saved")
            setSelectedNo(newTType)
            history.go("0")
          } else {
            toastr.error("Could not save Payee type")
          }
          setIsloading(false)
          preparePayeeNo(payeeType)
        })
        .catch(function (error) {
          toastr.error(error.response.data.error.message)
          setIsloading(false)
        })
    }
  }

  const updatePayeeType = e => {
    let req = {}
    req = {
      payeeType: e.target.value,
    }
    let newPType = e.target.value
    if (e.target.value != payeeType && paymentRequisitionLines.length > 0) {
      Swal.fire({
        title: "Are you sure?",
        text: "Modifying the Payee type will delete all associated payment requisition lines. This action is irreversible. Do you wish to proceed?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#019654",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, Proceed!",
      }).then(result => {
        if (result.isConfirmed) {
          setIsloading(true)
          const Config = {
            auth: {
              username: url.HRMIS,
              password: url.HRMISPASS,
            },
            headers: {
              "Content-Type": "application/json",
              "If-Match": "*",
            },
          }
          axios
            .get(
              `${url.PMTREQNLINES}?$filter=documentNo eq '${rNo}' &company=${CompanyID}`,
              Config
            )
            .then(res => {
              let resObj = res.data.value
              resObj.forEach((obj, index) => {
                console.log(resObj)
                const Config = {
                  auth: {
                    username: url.HRMIS,
                    password: url.HRMISPASS,
                  },
                  headers: {
                    "Content-Type": "application/json",
                    "If-Match": "*",
                  },
                }
                axios
                  .delete(
                    `${url.PMTREQNLINES}(${obj.id})?company=${CompanyID}`,
                    Config
                  )
                  .then(response => {
                    setIsloading(false)
                    setPayeeType(newPType)
                    prepareTransactionType(newPType)
                    setPayeeNo("")
                    setPayeeName("")
                    setWorkPlanNo("")
                    setSelectedNo2("")
                    axios
                      .patch(
                        `${url.PAYMENTS1}(${id})?company=${CompanyID}`,
                        JSON.stringify(req),
                        Config
                      )
                      .then(function (response) {
                        if (response.status == "200") {
                          toastr.info("Saving...")
                          setPayeeType(newPType)
                          setPayeeNo("")
                          setPayeeName("")
                          setWorkPlanNo("")
                          setSelectedNo2("")
                          history.go("0")
                          toastr.success("Saved")
                        } else {
                          toastr.error("Could not save Payee type")
                        }
                        setIsloading(false)
                        preparePayeeNo(payeeType)
                        getData()
                        history.go("0")
                      })
                      .catch(function (error) {
                        toastr.error(error.response.data.error.message)
                        setIsloading(false)
                        console.log(error)
                      })
                  })
                  .catch(error => {
                    toastr.error(error.response.data.error.message)
                    setIsloading(false)
                  })
              })
              if (resObj.length == 0) {
                toastr.info(
                  "Payment requisition Lines have been cleared. You can now create new lines."
                )
                setIsloading(false)
                setPayeeType(newPType)
                prepareTransactionType(newPType)
                setPayeeNo("")
                setPayeeName("")
                setWorkPlanNo("")
                setSelectedNo2("")
                history.go("0")
              }
            })
            .catch(error => {
              toastr.error(error.response.data.error.message)
              console.log(error)
              setIsloading(false)
            })
        }
      })
    }

    if (payeeType != "" && paymentRequisitionLines.length == 0) {
      toastr.info("Saving...")
      const Config = {
        auth: {
          username: url.HRMIS,
          password: url.HRMISPASS,
        },
        headers: {
          "Content-Type": "application/json",
          "If-Match": "*",
        },
      }
      axios
        .patch(
          `${url.PAYMENTS1}(${id})?company=${CompanyID}`,
          JSON.stringify(req),
          Config
        )
        .then(function (response) {
          if (response.status == "200") {
            getData()
            history.go("0")
            setSelectedNo2("")

            toastr.success("Saved")
          } else {
            toastr.error("Could not save Payee type")
          }
          setIsloading(false)
          getData()
        })
        .catch(function (error) {
          toastr.error(error.response.data.error.message)
          setIsloading(false)
        })
    }
    if (payeeType == "" && paymentRequisitionLines.length == 0) {
      toastr.info("Saving...")
      const Config = {
        auth: {
          username: url.HRMIS,
          password: url.HRMISPASS,
        },
        headers: {
          "Content-Type": "application/json",
          "If-Match": "*",
        },
      }
      axios
        .patch(
          `${url.PAYMENTS1}(${id})?company=${CompanyID}`,
          JSON.stringify(req),
          Config
        )
        .then(function (response) {
          if (response.status == "200") {
            getData()
            history.go("0")
            toastr.success("Saved")
          } else {
            toastr.error("Could not save Payee type")
          }
          setIsloading(false)
          getData()
        })
        .catch(function (error) {
          toastr.error(error.response.data.error.message)
          setIsloading(false)
        })
    }
  }
  const fetchSubgranteeTransactionType = async () => {
    axios
      .get(
        `${url.REQNTRANSACTIONTYPE}?$filter=transactionType eq 'Subgrantee' &company=${CompanyID}`,
        HRConfig
      )
      .then(r => {
        let options = []
        r.data.value.map(a => {
          options.push({
            value: a.no,
            label: `${a.no} ${": "} ${a.description}`,
          })
        })
        setNoo(options)

        setIsloading(false)
      })
      .catch(e => {
        console.log(e)
        setIsloading(false)
      })
  }
  const fetchBankTransfersTransactionType = async () => {
    axios
      .get(
        `${url.REQNTRANSACTIONTYPE}?$filter=transactionType eq 'Bank Transfers' &company=${CompanyID}`,
        HRConfig
      )
      .then(r => {
        let options = []
        r.data.value.map(a => {
          options.push({ value: a.no, label: `${a.no} ${": "} ${a.name}` })
        })
        setNoo(options)
        setNoo1(options)
        setIsloading(false)
      })
      .catch(e => {
        console.log(e)
        setIsloading(false)
      })
  }
  const fetchStatutoryBodiesTransactionType = async () => {
    axios
      .get(
        `${url.REQNTRANSACTIONTYPE}?$filter=transactionType eq 'Statutory Bodies' &company=${CompanyID}`,
        HRConfig
      )
      .then(r => {
        let options = []
        r.data.value.map(a => {
          options.push({
            value: a.no,
            label: `${a.no} ${": "} ${a.description}`,
          })
        })
        setNoo(options)
        setNoo1(options)
        setIsloading(false)
      })
      .catch(e => {
        console.log(e)
        setIsloading(false)
      })
  }
  const fetchStaffTransactionType = async () => {
    axios
      .get(
        `${url.REQNTRANSACTIONTYPE}?$filter=transactionType eq 'Staff' &company=${CompanyID}`,
        HRConfig
      )
      .then(r => {
        let options = []
        r.data.value.map(a => {
          options.push({
            value: a.no,
            label: `${a.no} ${": "} ${a.description}`,
          })
        })
        setNoo(options)

        setIsloading(false)
      })
      .catch(e => {
        console.log(e)
        setIsloading(false)
      })
  }
  const fetchVendorTransactionType = async () => {
    axios
      .get(
        `${url.REQNTRANSACTIONTYPE}?$filter=transactionType eq 'Vendor' &company=${CompanyID}`,
        HRConfig
      )
      .then(r => {
        let options = []
        r.data.value.map(a => {
          options.push({
            value: a.no,
            label: `${a.no} ${": "} ${a.description}`,
          })
        })
        setNoo(options)
        setIsloading(false)
      })
      .catch(e => {
        console.log(e)
        setIsloading(false)
      })
  }
  const fetchCustomers = async () => {
    axios
      .get(
        `${url.CUSTOMERS}?$filter=customerPostingGroup eq 'STAFF' &company=${CompanyID}`,
        HRConfig
      )
      .then(r => {
        let options = []
        r.data.value.map(a => {
          options.push({ value: a.no, label: `${a.no} ${": "} ${a.name}` })
        })
        setNoo(options)
        setIsloading(false)
      })
      .catch(e => {
        console.log(e)
        setIsloading(false)
      })
  }
  const fetchVendors = async () => {
    axios
      .get(url.VENDORS + "?company=" + CompanyID, HRConfig)
      .then(r => {
        let options = []
        r.data.value.map(a => {
          options.push({ value: a.no, label: `${a.no} ${": "} ${a.name}` })
        })
        setNoo1(options)
        setIsloading(false)
      })
      .catch(e => {
        console.log(e)
        setIsloading(false)
      })
  }
  // const fetchBankAccounts = async() => {
  //     axios.get(url.BANKACCOUNTS +"?company=" + CompanyID, HRConfig).then((r)=>{
  //         let options = []
  //         r.data.value.map((a)=>{options.push({value:a.no, label:`${a.name}`})})
  //         setNoo1(options);
  //         setIsloading(false)
  //         }). catch((e)=>{
  //             console.log(e)
  //             setIsloading(false)
  //     })
  // }
  const fetchSubgrantees = async () => {
    axios
      .get(
        `${url.CUSTOMERS}?$filter=customerPostingGroup eq 'SUB-OVC' or customerPostingGroup eq 'SUB PNFPS' or customerPostingGroup eq 'SUB DIST' &company=${CompanyID}`,
        HRConfig
      )
      .then(r => {
        let options = []
        r.data.value.map(a => {
          options.push({ value: a.no, label: `${a.no} ${": "} ${a.name}` })
        })
        setNoo1(options)
        setIsloading(false)
      })
      .catch(e => {
        console.log(e)
        setIsloading(false)
      })
  }
  const fetchStatutoryBodies = async () => {
    let options = []
    setNoo1(options)
    setNoo(options)
    setIsloading(false)
  }
  const prepareTransactionType = async newPType => {
    setSelectedType(newPType)
    setIsloading(true)
    setSelectedNo2("")
    if (newPType == "Staff") {
      fetchStaffTransactionType(newPType)
    } else if (newPType == "Vendor") {
      fetchVendorTransactionType(newPType)
    } else if (newPType == "Subgrantee") {
      fetchSubgranteeTransactionType(newPType)
    } else if (newPType == "Statutory Bodies") {
      fetchStatutoryBodiesTransactionType(newPType)
    } else if (newPType == "Bank Transfers") {
      fetchBankTransfersTransactionType(newPType)
    } else {
      setNoo([])
      setIsloading(false)
    }
  }

  const preparePayeeNo = async payeeType => {
    setIsloading(true)
    if (payeeType == "Staff") {
      fetchCustomers()
    } else if (payeeType == "Vendor") {
      fetchVendors()
    } else if (payeeType == "Subgrantee") {
      fetchSubgrantees()
    } else if (payeeType == "Statutory Bodies") {
      fetchStatutoryBodies()
    } else if (payeeType == "Bank Transfers") {
      fetchBankAccounts()
    } else if (payeeType == "Vendor") {
      fetchVendors()
    } else {
      setNoo([])
      setIsloading(false)
    }
  }

  const updateActivityStartDate = e => {
    if (RStatus != "Open") {
      toastr.error(
        "You cannot edit Payment requisitions that have already been submitted for approval or have been approved!"
      )
    } else {
      let newexprecdate = e
      if (e != "") {
        let req = {}
        req = {
          activityStartDate: e,
        }
        toastr.info("Saving...")
        const Config = {
          auth: {
            username: url.HRMIS,
            password: url.HRMISPASS,
          },
          headers: {
            "Content-Type": "application/json",
            "If-Match": "*",
          },
        }
        axios
          .patch(
            `${url.PAYMENTS1}(${id})?company=${CompanyID}`,
            JSON.stringify(req),
            Config
          )
          .then(function (response) {
            if (response.status == "200") {
              toastr.success("Saved")
              setActivityStartDate(newexprecdate)
            } else {
              toastr.error("Could not save Activity start date")
            }
            setIsloading(false)
          })
          .catch(function (error) {
            toastr.error(error.response.data.error.message)
            setIsloading(false)
          })
      }
    }
  }

  const handleChangeWorkPlanNo = e => {
    let newWPNo2 = e.target.value
    if (
      workplanno != "" &&
      e.target.value != workplanno &&
      paymentRequisitionLines.length > 0
    ) {
      Swal.fire({
        title: "Are you sure?",
        text: "Modifying the Workplan No. will delete all associated payment requisition lines. This action is irreversible. Do you wish to proceed?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#019654",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, Proceed!",
      }).then(result => {
        if (result.isConfirmed) {
          setIsloading(true)
          const Config = {
            auth: {
              username: url.HRMIS,
              password: url.HRMISPASS,
            },
            headers: {
              "Content-Type": "application/json",
              "If-Match": "*",
            },
          }
          axios
            .get(
              `${url.PMTREQNLINES}?$filter=documentNo eq '${rNo}' &company=${CompanyID}`,
              Config
            )
            .then(res => {
              let resObj = res.data.value
              resObj.forEach((obj, index) => {
                console.log(resObj)
                const Config = {
                  auth: {
                    username: url.HRMIS,
                    password: url.HRMISPASS,
                  },
                  headers: {
                    "Content-Type": "application/json",
                    "If-Match": "*",
                  },
                }
                axios
                  .delete(
                    `${url.PMTREQNLINES}(${obj.id})?company=${CompanyID}`,
                    Config
                  )
                  .then(response => {
                    setIsloading(false)
                    setWorkPlanNo(newWPNo2)
                    handleChangeWorkPlanNo2(newWPNo2)
                  })
                  .catch(error => {
                    toastr.error(error.response.data.error.message)
                    setIsloading(false)
                  })
              })
              if (resObj.length == 0) {
                toastr.info(
                  "Payment requisition Lines have been cleared. You can now create new lines."
                )
                setIsloading(false)
                setWorkPlanNo(newWPNo2)
                handleChangeWorkPlanNo2(newWPNo2)
              }
            })
            .catch(err => {
              toastr.error(err.response.data.error.message)
              setIsloading(false)
            })
        }
      })
    }
    if (workplanno != "" && paymentRequisitionLines.length == 0) {
      setWorkPlanNo(e.target.value)
      let req = {}
      req = {
        workPlanNo: e.target.value,
      }
      toastr.info("Saving...")
      const Config = {
        auth: {
          username: url.HRMIS,
          password: url.HRMISPASS,
        },
        headers: {
          "Content-Type": "application/json",
          "If-Match": "*",
        },
      }
      axios
        .patch(
          `${url.PAYMENTS1}(${id})?company=${CompanyID}`,
          JSON.stringify(req),
          Config
        )
        .then(function (response) {
          if (response.status == "200") {
            toastr.success("Saved")
          } else {
            toastr.error("Could not save work plan No.")
          }
          setIsloading(false)
        })
        .catch(function (error) {
          toastr.error(error.response.data.error.message)
          setIsloading(false)
        })
    }
    if (workplanno == "" && paymentRequisitionLines.length == 0) {
      setWorkPlanNo(e.target.value)
      let req = {}
      req = {
        workPlanNo: e.target.value,
      }
      toastr.info("Saving...")
      const Config = {
        auth: {
          username: url.HRMIS,
          password: url.HRMISPASS,
        },
        headers: {
          "Content-Type": "application/json",
          "If-Match": "*",
        },
      }
      axios
        .patch(
          `${url.PAYMENTS1}(${id})?company=${CompanyID}`,
          JSON.stringify(req),
          Config
        )
        .then(function (response) {
          if (response.status == "200") {
            toastr.success("Saved")
          } else {
            toastr.error("Could not save Work Plan No.")
          }
          setIsloading(false)
        })
        .catch(function (error) {
          toastr.error(error.response.data.error.message)
          setIsloading(false)
        })
    }
  }

  const updateActivityEndDate = e => {
    if (RStatus != "Open") {
      toastr.error(
        "You cannot edit Payment requisitions that have already been submitted for approval or have been approved!"
      )
    } else {
      let newexprecdate = e
      if (e != "") {
        let req = {}
        req = {
          activityEndDate: e,
        }
        toastr.info("Saving...")
        const Config = {
          auth: {
            username: url.HRMIS,
            password: url.HRMISPASS,
          },
          headers: {
            "Content-Type": "application/json",
            "If-Match": "*",
          },
        }
        axios
          .patch(
            `${url.PAYMENTS1}(${id})?company=${CompanyID}`,
            JSON.stringify(req),
            Config
          )
          .then(function (response) {
            if (response.status == "200") {
              toastr.success("Saved")
              setActivityEndDate(newexprecdate)
            } else {
              toastr.error("Could not save Activity end date")
            }
            setIsloading(false)
          })
          .catch(function (error) {
            toastr.error(error.response.data.error.message)
            setIsloading(false)
          })
      }
    }
  }

  const handlePayeeTypeChange = type => {
    setSelectedPayee(null)
    //setPayeeNo('')
    //setPayeeName('')
    setPayeeOptions([])
    setAccType(["G/L Account"])
    let options = []
    if (type == "") {
      setShowPayeeNo(false)
    } else {
      setShowPayeeNo(true)
    }
    // if(type == "Customer"){
    //     setAccType(['G/L Account', 'Customer'])
    //     setIsloading(true)
    //     axios.get(`${url.PAYEETYPE_CUSTOMER}`, HRConfig).then((r)=>{
    //         r.data.value.map((v)=>{
    //             options.push({'label': v.customerName,'value':v.customerNo})
    //         })
    //         setPayeeOptions(options)
    //         setIsloading(false)
    //     }).catch((e)=>{
    //         console.log(e)
    //         setIsloading(false)
    //     })
    // }
    // if(type == "Vendor"){
    //     setAccType(['Vendor'])
    //     setIsloading(true)
    //     axios.get(`${url.PAYEETYPE_VENDOR}`, HRConfig).then((r)=>{
    //         r.data.value.map((v)=>{
    //             options.push({'label': v.vendorName,'value':v.vendorNo})
    //         })
    //         setPayeeOptions(options)
    //         setIsloading(false)
    //     }).catch((e)=>{
    //         console.log(e)
    //         setIsloading(false)
    //     })
    // }
    // if(type == "Bank"){
    //     setAccType(['Bank Account'])
    //     setIsloading(true)
    //     axios.get(`${url.PAYEETYPE_BANK}`, HRConfig).then((r)=>{
    //         r.data.value.map((v)=>{
    //             options.push({'label': v.bankName,'value':v.bankNo})
    //         })
    //         setPayeeOptions(options)
    //         setIsloading(false)
    //     }).catch((e)=>{
    //         console.log(e)
    //         setIsloading(false)
    //     })
    // }
    // if((type == "Employee")){
    //     setAccType(['G/L Account'])
    //     setIsloading(true)
    //     axios.get(`${url.PAYEETYPE_IMPREST}`, HRConfig).then((r)=>{
    //         r.data.value.map((v)=>{
    //             options.push({'label': v.customerName,'value':v.customerNo})
    //         })
    //         setPayeeOptions(options)
    //         setIsloading(false)
    //     }).catch((e)=>{
    //         console.log(e)
    //         setIsloading(false)
    //     })
    // }
    // if((type == "Imprest")){
    //     setAccType(['G/L Account'])
    //     setIsloading(true)
    //     axios.get(`${url.PAYEETYPE_IMPREST}`, HRConfig).then((r)=>{
    //         r.data.value.map((v)=>{
    //             options.push({'label': v.customerName,'value':v.customerNo})
    //         })
    //         setPayeeOptions(options)
    //         setIsloading(false)
    //     }).catch((e)=>{
    //         console.log(e)
    //         setIsloading(false)
    //     })
    // }
  }
  const handleSelectedPayee = p => {
    // setSelectedPayee(p)
    // setSelectedNo2(p.value)
    // setPayeeName(p.label)
    // setNoo([{label:p.label, value:p.value}])

    let newPayeeNo = p.value
    if (p.value != selectedNo2 && paymentRequisitionLines.length > 0) {
      Swal.fire({
        title: "Are you sure?",
        text: "Modifying the Payee No. will delete all associated payment requisition lines. This action is irreversible. Do you wish to proceed?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#019654",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, Proceed!",
      }).then(result => {
        if (result.isConfirmed) {
          setIsloading(true)
          const Config = {
            auth: {
              username: url.HRMIS,
              password: url.HRMISPASS,
            },
            headers: {
              "Content-Type": "application/json",
              "If-Match": "*",
            },
          }
          axios
            .get(
              `${url.PMTREQNLINES}?$filter=documentNo eq '${rNo}' &company=${CompanyID}`,
              Config
            )
            .then(res => {
              let resObj = res.data.value
              resObj.forEach((obj, index) => {
                console.log(resObj)
                const Config = {
                  auth: {
                    username: url.HRMIS,
                    password: url.HRMISPASS,
                  },
                  headers: {
                    "Content-Type": "application/json",
                    "If-Match": "*",
                  },
                }
                let req = {}
                req = {
                  payeeNo: newPayeeNo,
                }

                axios
                  .delete(
                    `${url.PMTREQNLINES}(${obj.id})?company=${CompanyID}`,
                    Config
                  )
                  .then(response => {
                    setIsloading(false)
                    setSelectedNo2(newPayeeNo)
                  })
                  .catch(error => {
                    toastr.error(error.response.data.error.message)
                    setIsloading(false)
                  })

                axios
                  .patch(
                    `${url.PAYMENTS1}(${id})?company=${CompanyID}`,
                    JSON.stringify(req),
                    Config
                  )
                  .then(function (response) {
                    if (response.status == "200") {
                      toastr.success("Saved")
                      setSelectedNo2(newPayeeNo)
                      history.go("0")
                    } else {
                      toastr.error("Could not save Payee No.")
                    }
                    setIsloading(false)
                    preparePayeeNo(payeeType)
                    history.go("0")
                  })
                  .catch(function (error) {
                    toastr.error(error.response.data.error.message)
                    setIsloading(false)
                  })
              })
              if (resObj.length == 0) {
                toastr.info(
                  "Payment requisition Lines have been cleared. You can now create new lines."
                )
                setIsloading(false)
                setSelectedNo2(newPayeeNo)
                preparePayeeNo(payeeType)
              }
            })
            .catch(function (error) {
              toastr.error(err.response.data.error.message)
              setIsloading(false)
            })
        }
      })
    }

    if (selectedNo2 != "" && paymentRequisitionLines.length == 0) {
      let req = {}
      req = {
        payeeNo: p.value,
      }
      toastr.info("Saving...")
      const Config = {
        auth: {
          username: url.HRMIS,
          password: url.HRMISPASS,
        },
        headers: {
          "Content-Type": "application/json",
          "If-Match": "*",
        },
      }
      axios
        .patch(
          `${url.PAYMENTS1}(${id})?company=${CompanyID}`,
          JSON.stringify(req),
          Config
        )
        .then(function (response) {
          if (response.status == "200") {
            toastr.success("Saved")
            setSelectedNo2(newPayeeNo)
            getData()
          } else {
            toastr.error("Could not save Payee No.")
          }
          setIsloading(false)
          preparePayeeNo(payeeType)
        })
        .catch(function (error) {
          toastr.error(error.response.data.error.message)
          setIsloading(false)
        })
    }

    if (selectedNo2 == "" && paymentRequisitionLines.length == 0) {
      let req = {}
      req = {
        payeeNo: p.value,
      }
      toastr.info("Saving...")
      const Config = {
        auth: {
          username: url.HRMIS,
          password: url.HRMISPASS,
        },
        headers: {
          "Content-Type": "application/json",
          "If-Match": "*",
        },
      }
      axios
        .patch(
          `${url.PAYMENTS1}(${id})?company=${CompanyID}`,
          JSON.stringify(req),
          Config
        )
        .then(function (response) {
          if (response.status == "200") {
            toastr.success("Saved")
            setSelectedNo2(newPayeeNo)
            getData()
          } else {
            toastr.error("Could not save Payee No")
          }
          setIsloading(false)
        })
        .catch(function (error) {
          toastr.error(error.response.data.error.message)
          setIsloading(false)
        })
    }
  }
  const handleAddLine = () => {
    setIsEdit(false)
    setIsloading(true)
    tog_line()
    setAccountType("")
    setAccountNo("")
    setAccountName("")
    setQuantity("")
    setRate("")
    setAmount("")
    setAmountLCY("")
    setNarration("")
    setSelectedType("")
    setWorkPlanEntryNo("")
    setQuantity("")
    setLineSystemId("")
    setIsloading(false)
  }
  const handleComments = () => {
    setIsEdit(false)
    setIsloading(true)
    tog_comments()
    setIsloading(false)
  }
  const handleAddLine2 = () => {
    if (accountType == "") {
      toastr.error("Account Type must not be blank!")
    } else {
      setIsloading(true)
      const Config = {
        auth: {
          username: url.HRMIS,
          password: url.HRMISPASS,
        },
        headers: {
          "Content-Type": "application/json",
          "If-Match": "*",
        },
      }
      const data = {
        documentNo: rNo,
        accountType: accountType,
        accountNo: accountNo,
        workPlanEntryNo: parseInt(workPlanEntryNo),
        narration: narration,
        quantity: parseInt(quantity),
        rate: parseInt(rate),
        whtAmountOnVAT: parseInt(whtAmountOnVAT),
        amountToPay: parseInt(amountToPay),
        whtAmount: parseInt(whtamount),
        // shortcutDimension1Code  :   fundsource
      }
      axios
        .post(
          `${url.PMTREQNLINES}?company='${CompanyID}'`,
          JSON.stringify(data),
          Config
        )
        .then(r => {
          if (r.request.status == "201") {
            toastr.success("Payment Requisition line added successfully!")
            tog_line(false)
            getData()
            clearLineData()
            setIsloading(false)
          } else {
            toastr.error("Could not create purchase requisition!")
            setIsloading(false)
          }
        })
        .catch(function (error) {
          toastr.error(error.response.data.error.message)
          setIsloading(false)
        })
    }
  }
  const handleUpdateLine = () => {
    setIsloading(true)
    const Config = {
      auth: {
        username: url.HRMIS,
        password: url.HRMISPASS,
      },
      headers: {
        "Content-Type": "application/json",
        "If-Match": "*",
      },
    }
    const data = {
      documentNo: rNo,
      accountType: accountType,
      accountNo: accountNo,
      workPlanEntryNo: parseInt(workPlanEntryNo),
      narration: narration,
      quantity: parseInt(quantity),
      rate: parseInt(rate),
      whtAmountOnVAT: parseInt(whtAmountOnVAT),
      amountToPay: parseInt(amountToPay),
      whtAmount: parseInt(whtamount),
      // shortcutDimension1Code  :   fundsource
    }
    axios
      .patch(
        `${url.PMTREQNLINES}(${lineSystemId})?company=${CompanyID}`,
        JSON.stringify(data),
        Config
      )
      .then(r => {
        if (r.request.status == "200") {
          toastr.success("Payment Requisition updated successfully!")
          tog_line(false)
          getData()
          clearLineData()
          setIsloading(false)
        } else {
          toastr.error("Could not update purchase requisition!")
          setIsloading(false)
        }
      })
      .catch(function (error) {
        toastr.error(error.response.data.error.message)
        setIsloading(false)
      })
  }
  const handleCancelApprovalRequest = e => {
    if (cancellationcomment == "") {
      toastr.error(
        "Please fill in a cancellation comment. It must not be blank!"
      )
    } else {
      Swal.fire({
        title: "Are you sure?",
        text: "This will cancel approval for the Payment requisition. Do you wish to proceed?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#019654",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, Proceed!",
        cancelButtonText: "Cancel",
      }).then(result => {
        if (result.isConfirmed) {
          setIsloading(true)
          const lNo = {
            no: rNo,
            cancelComment: cancellationcomment,
          }
          axios
            .post(
              url.PMTREQNCANCELAPPROVAL + "?company=" + CompanyID,
              JSON.stringify(lNo),
              HRConfig
            )
            .then(function (response) {
              if (response.status == "200") {
                toastr.success("Approval Request Cancelled")
                history.go(0)
              } else {
                toastr.success("Could not Cancel Approval Request")
              }
              setIsloading(false)
            })
            .catch(function (error) {
              toastr.error(error.response.data.error.message)
              setIsloading(false)
            })
            .then(function () {
              setIsloading(false)
            })
        }
      })
    }
  }
  const handleApprovalRequest = e => {
    if (payeeType == "") {
      toastr.error("Payee type must not be blank!")
    } else if (selectedNo == "") {
      toastr.error("Transaction type must not be blank!")
    } else if (purpose == "") {
      toastr.error("Purpose must not be blank!")
    } else {
      Swal.fire({
        title: "Are you sure?",
        text: "This will send the Payment requisition and its associated lines for approval. Do you wish to proceed?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#019654",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, Proceed!",
        cancelButtonText: "Cancel",
      }).then(result => {
        if (result.isConfirmed) {
          setIsloading(true)
          const lNo = { no: rNo }
          axios
            .post(
              url.PMTREQNAPPROVALREQUEST + "?company=" + CompanyID,
              JSON.stringify(lNo),
              HRConfig
            )
            .then(function (response) {
              if (response.status == "200") {
                toastr.success("Payment requisition has been sent for Approval")
                history.go(0)
              } else {
                toastr.success(
                  "Could not send purchase requisition for Approval"
                )
              }
              setIsloading(false)
            })
            .catch(function (error) {
              toastr.error(error.response.data.error.message)
              setIsloading(false)
              console.log(error)
            })
            .then(function () {
              setIsloading(false)
              // always executed
            })
        }
      })
    }
  }
  // const handleDownloadReport = async () => {
  //     const data = {no:no}
  //     setIsloading(true)
  //     axios.post(url.PRINTPAYMENTREQUISITION, JSON.stringify(data), HRConfig).then((r)=>{
  //       const urlx = process.env.REACT_APP_APACHE_URL + r.data.value
  //         axios({
  //           url: urlx,
  //           method: 'GET',
  //           responseType: 'blob',
  //         })
  //           .then(response => {
  //             const url = window.URL.createObjectURL(new Blob([response.data]));
  //             const link = document.createElement('a');
  //             link.href = url;
  //             link.setAttribute('download', 'Payment-requisition.pdf');
  //             document.body.appendChild(link);
  //             link.click();
  //             document.body.removeChild(link);
  //             setIsloading(false)
  //           })
  //           .catch(error => {
  //             console.error('Error downloading file:', error);
  //             toastr.error(error)
  //             setIsloading(false)
  //           });

  //       setIsloading(false)
  //     }).catch((e)=>{
  //       console.log(e)
  //       setIsloading(false)
  //     })
  // }
  const handleChange = event => {
    const name = event.target.name
    const value = event.target.value
    setInputs(values => ({ ...values, [name]: value }))
  }
  const handleEditManagement = k => {
    setAddDetails(true)
    setEditLine(true)
    setApplnID(managementActivities[k].id)
    setApplyEntry(managementActivities[k].applyEntry)
    setApplnPostingDate(managementActivities[k].postingDate)
    setApplnDocumentType(managementActivities[k].documentType)
    setApplnDocumentNo(managementActivities[k].documentNo)
    setApplnExtDocNo(managementActivities[k].externalDocNo)
    setApplnDescription(managementActivities[k].description)
    setApplnCurrencyCode(managementActivities[k].curCode)
    setRemainingAmount(managementActivities[k].remainingAmount)
    setApplnRemainingAmount(managementActivities[k].applnremainingAmount)
  }
  // const handleTypeChange = (e) =>{
  //     setSelectedType(e.target.value)
  //     setSelectedNo(null)
  //     setIsloading(true)
  //     setSelectedPayee('')
  //     let options = []
  //     if(e.target.value == 'G/L Account'){
  //         axios.get(url.GLACC, HRConfig).then((r)=>{
  //             setIsloading(false)
  //             r.data.value.map((a)=>{
  //                 options.push({label:a.glAccountName, value:a.glAccountNo})
  //             })
  //             setNoo(options)
  //         }).catch((e)=>{
  //             setIsloading(false)
  //             console.log(e)
  //         })

  //     }else if(e.target.value == "Vendor"){
  //         setIsloading(true)
  //         axios.get(`${url.PAYEETYPE_VENDOR}`, HRConfig).then((r)=>{
  //             r.data.value.map((v)=>{
  //                 options.push({'label': v.vendorName,'value':v.vendorNo})
  //             })
  //             setNoo(options)
  //             setIsloading(false)
  //         }).catch((e)=>{
  //             console.log(e)
  //             setIsloading(false)
  //         })
  //     }else if(e.target.value == "Bank Account"){
  //         setIsloading(true)
  //         axios.get(`${url.PAYEETYPE_BANK}`, HRConfig).then((r)=>{
  //             r.data.value.map((v)=>{
  //                 options.push({'label': v.bankName,'value':v.bankNo})
  //             })
  //             setNoo(options)
  //             setIsloading(false)
  //         }).catch((e)=>{
  //             console.log(e)
  //             setIsloading(false)
  //         })
  //     }else if(e.target.value == "Customer"){
  //         setIsloading(true)
  //         axios.get(`${url.PAYEETYPE_CUSTOMER}`, HRConfig).then((r)=>{
  //             r.data.value.map((v)=>{
  //                 options.push({'label': v.customerName,'value':v.customerNo})
  //             })
  //             setNoo(options)
  //             setIsloading(false)
  //         }).catch((e)=>{
  //             console.log(e)
  //             setIsloading(false)
  //         })
  //     }else{
  //         setIsloading(false)
  //     }
  // }
  const handleNoChange = e => {
    console.log(accountType)
    setAccountNo(e.value)
    if (accountType == "Bank Account") {
      fetchBankAccounts(e.value)
    }
    if (accountType == "G/L Account") {
      fetchGLWorkplanEntryNo(e.value)
    }
    if (accountType == "Non Workplan- G/L") {
      fetchNonGLWorkplanEntryNo(e.value)
    }
  }
  const handleFundsourcechange = e => {
    console.log(fundsource)
    setFundSource(e.value)
  }
  const fetchGLWorkplanEntryNo = newNo => {
    axios
      .get(
        `${url.WORKPLANENTRYNO}?$filter=workPlanNo eq '${workplanno}' and gLAcccount eq '${newNo}' &company=${CompanyID}`,
        HRConfig
      )
      .then(r => {
        setWorkPlanEntry(r.data.value)
      })
      .catch(e => {
        console.log(e)
        setIsloading(false)
      })
  }
  const fetchNonGLWorkplanEntryNo = newNo => {
    axios
      .get(
        `${url.WORKPLANENTRYNO}?$filter=workPlanNo eq '${workplanno}' and gLAcccount eq '${newNo}' &company=${CompanyID}`,
        HRConfig
      )
      .then(r => {
        setWorkPlanEntry(r.data.value)
      })
      .catch(e => {
        console.log(e)
        setIsloading(false)
      })
  }
  const getData = () => {
    let obj = JSON.parse(localStorage.getItem("authMildUser"))
    let EmployeeNo = obj.uid
    const navUserName = obj.username
    setCompanyID(obj.activeCompany)
    setEmployeeNo1(obj.uid)
    setIsloading(true)
    axios
      .get(
        url.PAYMENTS1 +
          "(" +
          id +
          ")?$expand=paymentRequisitionLines" +
          "&company=" +
          obj.activeCompany,
        HRConfig
      )
      .then(function (r) {
        setRNo(r.data.no)
        setEmpNo(r.data.requisitioner)
        setEmpName(r.data.requisitionerName)
        setRStatus(r.data.status)
        setActivityStartDate(r.data.activityStartDate)
        setActivityEndDate(r.data.activityEndDate)
        setWorkPlanNo(r.data.workPlanNo)
        setPayeeType(r.data.payeeType)
        setSelectedNo(r.data.transactionType)
        setSelectedNo2(r.data.payeeNo)
        setExternalDocumentNo(r.data.externalDocumentNo)
        setRequisitionerNo(r.data.requisitioner)

        setAmount(r.data.totalAmount)
        setPaymentRequisitionLines(r.data.paymentRequisitionLines)
        setPaymentCategory(r.data.paymentCategory)

        if (r.data.payeeNo != "") {
          setShowPayeeNo(true)
        }
        setPayeeName(r.data.payeeName)
        setPayeeNo(r.data.payeeNo)
        setPurpose(r.data.purpose)
        setProjectCode(r.data.projectCode)
        setNo(r.data.paymentReqNo)
        setStatus(r.data.Status)
        setPaymentCategory(r.data.paymentCategory)
        setPaymentSubCategory(r.data.paySubcategory)
        handlePayeeTypeChange(r.data.payeeType)
        setCurrencyCode(r.data.currencyCode)

        axios
          .get(
            `${url.EMPLOYEES2}?$filter=No eq '${r.data.requisitioner}'&company=${obj.activeCompany}`,
            HRConfig
          )
          .then(response => {
            setEmpTitle(response.data.value[0].JobTitle)
            setDepartmentCode(response.data.value[0].Department_Code)
            setUserError(false)
            setIsloading(false)
          })
          .catch(function (error) {
            // toastr.error(error.response.data.error.message);
            setUserError(true)
            console.log(error)
            setIsloading(false)
          })
        axios
          .get(
            `${url.WORKPLANS}?$filter=department eq '${r.data.shortcutDim2Value}' &company=${obj.activeCompany}`,
            HRConfig
          )
          .then(r => {
            setWorkPlans(r.data.value)
          })
          .catch(e => {
            console.log(e)
            setIsloading(false)
          })
        axios
          .get(
            `${
              url.DIMENSIONS
            }?$filter=dimensionCode eq 'FUNDSOURCE' and blocked eq ${false} &company=${
              obj.activeCompany
            }`,
            HRConfig
          )
          .then(r => {
            let options = []
            r.data.value.map(a => {
              options.push({
                value: a.code,
                label: `${a.code} ${": "} ${a.name}`,
              })
            })
            setFundSourceDim(options)
            if (fundsourceDim.length > 0) {
              setIsloading(false)
            }
            setIsloading(false)
          })
          .catch(e => {
            console.log(e)
            setIsloading(false)
          })
        axios
          .get(
            `${url.APPROVALCOMMENTS}?$filter=document_Type eq 'Payment Requisition' and document_No eq '${r.data.no}' &company=${obj.activeCompany}`,
            HRConfig
          )
          .then(r => {
            setApprovalCommentLines(r.data.value)
          })

        axios
          .get(
            `${url.ATTACHDOCUMENTS}?$filter=DocumentType eq 'Payment Requisition' and No eq '${r.data.no}' &company=${obj.activeCompany}`,
            HRConfig
          )
          .then(rx => {
            setUploadedFiles(rx.data.value)
            setLoadingFiles(false)
          })
          .catch(ex => {
            console.log(ex)
            setLoadingFiles(false)
          })

        if (r.data.payeeType == "Staff") {
          axios
            .get(
              `${url.CUSTOMERS}?$filter=customerPostingGroup eq 'STAFF' &company=${obj.activeCompany}`,
              HRConfig
            )
            .then(r => {
              let options = []
              r.data.value.map(a => {
                options.push({
                  value: a.no,
                  label: `${a.no} ${": "} ${a.name}`,
                })
              })
              setNoo1(options)
              setIsloading(false)
            })
            .catch(e => {
              console.log(e)
              setIsloading(false)
            })
        }
        if (r.data.payeeType == "Salary Advance") {
          console.log(r.data.payeeType)
          axios
            .get(
              `${url.EMPLOYEES2}?$filter=Status eq 'Active' &company=${obj.activeCompany}`,
              HRConfig
            )
            .then(r => {
              let options = []
              r.data.value.map(a => {
                options.push({
                  value: a.No,
                  label: `${a.FirstName} ${a.LastName}`,
                })
              })
              setNoo1(options)
              setIsloading(false)
            })
            .catch(e => {
              console.log(e)
              setIsloading(false)
            })
        }
        if (r.data.payeeType == "Vendor") {
          axios
            .get(url.VENDORS + "?company=" + obj.activeCompany, HRConfig)
            .then(r => {
              let options = []
              r.data.value.map(a => {
                options.push({
                  value: a.no,
                  label: `${a.no} ${": "} ${a.name}`,
                })
              })
              setNoo1(options)
              setIsloading(false)
            })
            .catch(e => {
              console.log(e)
              setIsloading(false)
            })
        }
        if (r.data.payeeType == "Subgrantee") {
          axios
            .get(
              `${url.CUSTOMERS}?$filter=customerPostingGroup eq 'SUB-OVC' or customerPostingGroup eq 'SUB PNFPS' or customerPostingGroup eq 'SUB DIST' &company=${obj.activeCompany}`,
              HRConfig
            )
            .then(r => {
              let options = []
              r.data.value.map(a => {
                options.push({
                  value: a.no,
                  label: `${a.no} ${": "} ${a.name}`,
                })
              })
              setNoo1(options)
              setIsloading(false)
            })
            .catch(e => {
              console.log(e)
              setIsloading(false)
            })
        }
        if (r.data.payeeType == "Bank Transfers") {
          axios
            .get(url.BANKACCOUNTS + "?company=" + obj.activeCompany, HRConfig)
            .then(r => {
              let options = []
              r.data.value.map(a => {
                options.push({
                  value: a.no,
                  label: `${a.no} ${": "} ${a.name}`,
                })
              })
              setNoo1(options)
              setIsloading(false)
            })
            .catch(e => {
              console.log(e)
              setIsloading(false)
            })
        }
        axios
          .get(
            `${url.REQNTRANSACTIONTYPE}?$filter=transactionType eq '${r.data.payeeType}' &company=${obj.activeCompany}`,
            HRConfig
          )
          .then(r => {
            setTransactionTypesList(r.data.value)
          })
          .catch(e => {
            console.log(e)
            setIsloading(false)
          })
        axios
          .get(url.CURRENCIES + "?company=" + obj.activeCompany, HRConfig)
          .then(r => {
            setCurrencyList(r.data.value)
          })
          .catch(e => {
            console.log(e)
            setIsloading(false)
          })
      })
      .catch(e => {
        setIsloading(false)
        console.log(e)
      })
  }

  const clearLineData = () => {
    setIsEdit(false)
    tog_line()
    setAccountType("")
    setAccountNo("")
    setAccountName("")
    setQuantity(0)
    setRate(0)
    setAmount("")
    setAmountLCY("")
    setWHTPercentage("")
    setWHTAmount(0)
    setWHTAmountonVAT("")
    setVATAmount("")
    setAmounttoPay("")
    setAmountPaid("")
    setInstallmentAmount("")
    setNoofInstallments("")
    setNarration("")
    setFundSource("")
    setWorkPlanEntryNo("")
    setLineSystemId("")
    setIsloading(false)
  }
  const handleClickLineDetails = k => {
    const p = paymentRequisitionLines[k]
    setIsEdit(true)
    setIsloading(true)
    tog_line()
    setAccountType(p.accountType)
    setAccountNo(p.accountNo)
    setAccountName(p.accountName)
    setQuantity(p.quantity)
    setRate(p.rate)
    setAmount(p.amount)
    setAmountLCY(p.amountLCY)
    setNarration(p.narration)
    fetchGLWorkplanEntryNo(p.accountNo)
    setWorkPlanEntryNo(p.workPlanEntryNo)
    setLineSystemId(p.id)
    setWHTPercentage(p.whtPercentage)
    setWHTAmount(p.whtAmount)
    setWHTAmountonVAT(p.whtAmountOnVAT)
    setVATAmount(p.vatAmount)
    setAmounttoPay(p.amountToPay)
    setAmountPaid(p.amountPaid)
    setInstallmentAmount(p.installmentAmount)
    setNoofInstallments(p.noOfInstallments)
    setFundSource(p.shortcutDimension1Code)
    if (p.accountType == "Item") {
      fetchItms()
      setIsloading(false)
    } else if (p.accountType == "G/L Account") {
      fetchWorkplanGLAccounts()
      setIsloading(false)
    } else if (p.accountType == "None Workplan- G/L") {
      fetchNonWorkplanGLAccounts()
      setIsloading(false)
    } else if (p.accountType == "Fixed Asset") {
      fetchFA()
      setIsloading(false)
    } else {
      setNoo([])
      setIsloading(false)
    }
  }
  useEffect(() => {
    getData()
  }, [])

  const handleDelete = () => {
    Swal.fire({
      title: "Are you sure?",
      text: "This will delete the Payment requisition and its associated lines. You will not be able to recover this document!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#019654",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, Proceed!",
      cancelButtonText: "Cancel",
    }).then(result => {
      if (result.isConfirmed) {
        setIsloading(true)
        const lNo = { no: rNo }
        axios
          .post(
            url.DELETERECORD + "?company=" + CompanyID,
            JSON.stringify(lNo),
            HRConfig
          )
          .then(function (response) {
            console.log(response)
            if (response.status == "200") {
              toastr.success("Payment Requisition Deleted")
              history.push("/payment-requisitions")
            } else {
              toastr.error("Could not Delete payment Requisition!")
            }
            setIsloading(false)
          })
          .catch(function (error) {
            toastr.error(error.response.data.error.message)
            console.log(error)
            setIsloading(false)
          })
      }
    })
  }
  const handleDeleteLine2 = () => {
    Swal.fire({
      title: "Are you sure?",
      text: "This will delete the selected payment requision line. You will not be able to recover it!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#019654",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "Cancel",
    }).then(result => {
      if (result.isConfirmed) {
        setIsloading(true)
        const Config = {
          auth: {
            username: url.HRMIS,
            password: url.HRMISPASS,
          },
          headers: {
            "Content-Type": "application/json",
            "If-Match": "*",
          },
        }
        axios
          .delete(
            `${url.PMTREQNLINES}(${lineSystemId})?company=${CompanyID}`,
            Config
          )
          .then(function (r) {
            if (r.status == "204") {
              setIsloading(false)
              toastr.info("Payment requisition line deleted successfully")
              tog_line(false)
              getData()
              clearLineData()
            } else {
              toastr.error("Could not delete Payment Requisition line!!")
              setIsloading(false)
            }
          })
          .catch(e => {
            console.log(e)
            setIsloading(false)
          })
      }
    })
  }
  const handleApprovalHistory = () => {
    setIsloading(true)
    // axios.get(`${url.APPROVALHISTORY}?$filter=DocumentNo eq '${no}'`, HRConfig).then((r)=>{
    //     setAHistory(r.data.value)
    //     setIsloading(false)
    //     tog_history()
    // }).catch((e)=>{
    //     console.log(e)
    //     setIsloading(false)
    // })
  }

  const handleSelectedFiles = e => {
    const files = e.target.files
    setSelectedFile(Array.from(files))
  }
  const removeFile = clickedFile => {
    const Config = {
      auth: {
        username: url.HRMIS,
        password: url.HRMISPASS,
      },
      headers: {
        "Content-Type": "application/json",
        "If-Match": "*",
      },
    }
    setIsloading(true)
    axios
      .delete(
        `${url.ATTACHDOCUMENTS}(${clickedFile.SystemId})?company=${CompanyID}`,
        Config
      )
      .then(r => {
        toastr.warning("File deleted")
        getData()
      })
      .catch(e => {
        console.log(e)
        toastr.error(e.response.data.error.message)
        setIsloading(false)
      })
  }
  const handleDownload = clickedFile => {
    const base64String = clickedFile.FileContentsBase64
    const fileName = clickedFile.FileName
    const fileExtension = clickedFile.FileExtension
    const contentType = clickedFile.fileContentType
    downloadBase64File(base64String, fileName, fileExtension, contentType)
  }
  const handleSaveFiles = () => {
    selectedFile.forEach(f => {
      const reader = new FileReader()
      reader.readAsDataURL(f)
      reader.onloadend = () => {
        const base64Data = reader.result
        const fileName = f.name
        const fileExtension = fileName.split(".").pop()
        const fileData = {
          No: rNo,
          TableID: 51402255,
          FileName: fileName,
          DocumentType: "Payment Requisition",
          FileExtension: fileExtension,
          fileContentType: getContentTypeFromBase64(base64Data),
          FileContentsBase64: base64Data.split(",")[1],
        }
        setIsloading(true)
        axios
          .post(
            url.ATTACHDOCUMENTS + "?company=" + CompanyID,
            JSON.stringify(fileData),
            HRConfig
          )
          .then(r => {
            toastr.info(`${r.data.FileName} has been attached`)
            tog_attachments()
            getData()
          })
          .catch(e => {
            console.log(e)
            toastr.error(e.response.data.error.message)
            setIsloading(false)
          })
      }
    })
  }
  return (
    <LoadingOverlay
      active={isloading}
      spinner={<ClimbingBoxLoader />}
      text="Please wait..."
    >
      <div className="page-content">
        <MetaTags>
          <title>Payment Requisition Details | {url.APPNAME}</title>
        </MetaTags>
        <Container fluid={true}>
          <Breadcrumbs
            title="Payment Management"
            breadcrumbItem="Payment Requisition"
          />
          <Row className="justify-content-center mb-4">
            <div className="d-flex flex-wrap gap-5">
              {paymentRequisitionLines.length > 0 && RStatus == "Open" && (
                <Button
                  color="primary"
                  className="btn btn-primary btn-label waves-effect waves-light"
                  onClick={handleApprovalRequest}
                >
                  <i className="bx bx-send label-icon" /> Submit Payment
                  Requisition for Approval
                </Button>
              )}
              {RStatus == "Open" && (
                <Button
                  color="danger"
                  className="btn btn-primary btn-label waves-effect waves-light"
                  onClick={() => {
                    handleDelete()
                  }}
                >
                  <i className="bx bx-trash label-icon" /> Delete Payment
                  Requisition
                </Button>
              )}
              {RStatus == "Pending Approval" && (
                <Button
                  color="danger"
                  className="btn btn-primary btn-label waves-effect waves-light"
                  onClick={handleCancelApprovalRequest}
                >
                  <i className="mdi mdi-book-cancel-outline label-icon" />{" "}
                  Cancel Approval Request
                </Button>
              )}
              {approvalCommentLines.length > 0 && (
                <Button
                  color="info"
                  className="btn btn-primary btn-label waves-effect waves-light"
                  onClick={handleComments}
                >
                  <i className="bx bx-book-content label-icon" /> Rejection
                  Comments
                </Button>
              )}
            </div>
          </Row>

          <div>
            {ipaSaved == false ? (
              <Row>
                <Col xl={4}>
                  <Card>
                    <CardBody>
                      <CardTitle>Employee Details</CardTitle>
                      <div className="table-responsive">
                        <table className="table">
                          <tbody>
                            <tr>
                              <th scope="col"> Number</th>
                              <td scope="col"> {empNo} </td>
                            </tr>
                            <tr>
                              <th scope="col"> Name</th>
                              <td scope="col">{empName}</td>
                            </tr>
                            <tr>
                              <th scope="col">Position</th>
                              <td scope="col">{empTitle}</td>
                            </tr>
                            <tr>
                              <th scope="col">Department</th>
                              <td scope="col">{departmentcode}</td>
                            </tr>
                            <tr>
                              <th scope="col">Status</th>
                              <td scope="col">{RStatus}</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </CardBody>
                  </Card>
                  <div className="d-flex">
                    <div className="flex-grow-1 ms-1">
                      <ul className="list-unstyled vstack gap-2 mb-0">
                        <div className="d-grid gap-2">
                          {/* {(RStatus == 'Open') && (payeeType != 'Vendor') && (
                                                <Button color="warning" type="button" className="btn btnSubmitPlan" onClick={()=>{handleAddLine()}} >
                                                    <i className="mdi mdi-cash-refund"/>{" "}
                                                        Add Payment Requisition Line
                                                </Button>
                                                )}  */}
                          {/* {(RStatus == 'Open') && (payeeType == 'Vendor') && (selectedNo != '') && (selectedNo2 != '') && (paymentRequisitionLines.length < 1) && (
                                                <Button color="warning" type="button" className="btn btnSubmitPlan" onClick={()=>{handleAddLine()}} >
                                                    <i className="mdi mdi-cash-refund"/>{" "}
                                                        Add Payment Requisition Line
                                                </Button>
                                                )}
                                                {(RStatus == 'Open') && (payeeType == 'Staff') && (selectedNo != '') && (selectedNo2 != '') && (workplanno != '') && (
                                                <Button color="warning" type="button" className="btn btnSubmitPlan" onClick={()=>{handleAddLine()}} >
                                                    <i className="mdi mdi-cash-refund"/>{" "}
                                                        Add Payment Requisition Line
                                                </Button>
                                                )}
                                                {(RStatus == 'Open') && (payeeType == 'Staff') && ((selectedNo == 'SALARIES') || (selectedNo == 'SPECIALISTS')) && (
                                                <Button color="warning" type="button" className="btn btnSubmitPlan" onClick={()=>{handleAddLine()}} >
                                                    <i className="mdi mdi-cash-refund"/>{" "}
                                                        Add Payment Requisition Line
                                                </Button>
                                                )}
                                                {(RStatus == 'Open') && (payeeType == 'Subgrantee') && (workplanno != '') && (selectedNo != '') && (selectedNo2 != '') && (
                                                <Button color="warning" type="button" className="btn btnSubmitPlan" onClick={()=>{handleAddLine()}} >
                                                    <i className="mdi mdi-cash-refund"/>{" "}
                                                        Add Payment Requisition Line
                                                </Button>
                                                )}
                                                {(RStatus == 'Open') && (payeeType == 'Statutory Bodies') && (selectedNo != '') && (
                                                <Button color="warning" type="button" className="btn btnSubmitPlan" onClick={()=>{handleAddLine()}} >
                                                    <i className="mdi mdi-cash-refund"/>{" "}
                                                        Add Payment Requisition Line
                                                </Button>
                                                )}
                                                {(RStatus == 'Open') && (payeeType == 'OVC') && (selectedNo != '') && (workplanno != '') && (
                                                <Button color="warning" type="button" className="btn btnSubmitPlan" onClick={()=>{handleAddLine()}} >
                                                    <i className="mdi mdi-cash-refund"/>{" "}
                                                        Add Payment Requisition Line
                                                </Button>
                                                )}
                                                {(RStatus == 'Open') && (payeeType == 'Participants') && (selectedNo != '') && (workplanno != '') && (
                                                <Button color="warning" type="button" className="btn btnSubmitPlan" onClick={()=>{handleAddLine()}} >
                                                    <i className="mdi mdi-cash-refund"/>{" "}
                                                        Add Payment Requisition Line
                                                </Button>
                                                )}
                                                {(RStatus == 'Open') && (payeeType == 'Bank Transfers') && (selectedNo != '') && (selectedNo2 != '') && (
                                                <Button color="warning" type="button" className="btn btnSubmitPlan" onClick={()=>{handleAddLine()}} >
                                                    <i className="mdi mdi-cash-refund"/>{" "}
                                                        Add Payment Requisition Line
                                                </Button>
                                                )}
                                                {(RStatus == 'Open') && (payeeType == 'Salary Advance') && (selectedNo != '') && (selectedNo2 != '') && (workplanno != '') && (
                                                <Button color="warning" type="button" className="btn btnSubmitPlan" onClick={()=>{handleAddLine()}} >
                                                    <i className="mdi mdi-cash-refund"/>{" "}
                                                        Add Payment Requisition Line
                                                </Button>
                                                )}
                                                {(RStatus == 'Open') && (payeeType == 'Staff') && (selectedNo == 'DIRECT') && (
                                                <Button color="warning" type="button" className="btn btnSubmitPlan" onClick={()=>{handleAddLine()}} >
                                                    <i className="mdi mdi-cash-refund"/>{" "}
                                                        Add Payment Requisition Line
                                                </Button>
                                                )} */}
                          {/* {(RStatus == 'Open') && (
                                                    <Button color="danger" type="button" className="btn btnSubmitPlan" onClick={()=>{handleDelete()}} >
                                                        <i className="mdi mdi-delete"/>{" "}
                                                            Delete Payment Requisition
                                                    </Button>
                                                )} */}
                          {/* {(paymentRequisitionLines.length > 0) && (RStatus == 'Open') && (
                                                    <Button color="primary" type="button" className="btn btnSubmitPlan" onClick={handleApprovalRequest}>
                                                        <i className="mdi mdi-clipboard-check-outline"/>{" "}
                                                            Submit Payment Requisition for Approval
                                                    </Button>
                                                )} */}
                          {/* {(RStatus == 'Pending Approval') && (
                                                    <Button color="danger" type="button" className="btn btnSubmitPlan" onClick={handleCancelApprovalRequest}>
                                                        <i className="mdi mdi-book-cancel-outline"/>{" "}
                                                            Cancel Approval Request
                                                    </Button>
                                                )} */}
                          {/* {(approvalCommentLines.length > 0) && (
                                                    <Button color="info" type="button" className="btn btnSubmitPlan" onClick={handleComments}>
                                                        <i className="mdi mdi-cash-refund"/>{" "}
                                                            View Rejection Comments
                                                    </Button>
                                                )} */}
                        </div>
                      </ul>
                    </div>
                  </div>
                  <Card>
                    <CardBody>
                      <CardTitle>
                        <Row className="mb-2">
                          <Col sm={6}>Attachments ({uploadedFiles.length})</Col>

                          {RStatus == "Open" && (
                            <Col sm={6}>
                              <div className="text-sm-end">
                                <Button
                                  color="primary"
                                  className="btn btn-primary btn-label waves-effect waves-light"
                                  type="button"
                                  onClick={tog_attachments}
                                >
                                  <i className="mdi mdi-file-plus-outline label-icon" />{" "}
                                  Add File
                                </Button>
                              </div>
                            </Col>
                          )}
                        </Row>
                      </CardTitle>
                      {loadingFiles ? (
                        <>
                          <div className="text-center">
                            <div className="mb-4"></div>
                            <div>
                              <h5>Loading files ...</h5>
                              <p className="text-muted"></p>
                            </div>
                          </div>
                        </>
                      ) : uploadedFiles.length > 0 ? (
                        <div className="table-responsive">
                          <Table className="table table-striped table-sm mb-4">
                            <thead>
                              <tr>
                                <th>File</th>
                                <th></th>
                              </tr>
                            </thead>
                            <tbody>
                              {uploadedFiles.map((a, k) => (
                                <tr key={k}>
                                  <td style={{ verticalAlign: "middle" }}>
                                    <Link
                                      to="#"
                                      onClick={() =>
                                        handleDownload(uploadedFiles[k])
                                      }
                                    >
                                      {a.FileName}
                                    </Link>
                                  </td>
                                  <td
                                    style={{
                                      verticalAlign: "middle",
                                      textAlign: "center",
                                    }}
                                  >
                                    {" "}
                                    <>
                                      <div className="d-flex gap-3">
                                        {RStatus == "Open" && (
                                          <Link
                                            to="#"
                                            className="text-danger"
                                            onClick={() =>
                                              removeFile(uploadedFiles[k])
                                            }
                                          >
                                            <i
                                              className="mdi mdi-delete font-size-18"
                                              id="deletetooltip"
                                            />
                                            <UncontrolledTooltip
                                              placement="top"
                                              target="deletetooltip"
                                            >
                                              Delete
                                            </UncontrolledTooltip>
                                          </Link>
                                        )}
                                      </div>
                                    </>
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </Table>
                        </div>
                      ) : (
                        <div className="text-center">
                          <div className="mb-4">
                            <i className="mdi mdi-file text-warning display-4" />
                          </div>
                          <div>
                            <h5>No files attached, yet!</h5>
                            <p className="text-muted"></p>
                          </div>
                        </div>
                      )}
                    </CardBody>
                  </Card>
                </Col>
                <Col xl={8}>
                  <Card>
                    <CardBody>
                      <CardTitle>Requisition Details</CardTitle>
                      <Row>
                        <Col md={6}>
                          <div className="mb-3">
                            <label>Requisition No</label>
                            <input
                              type="text"
                              className="form-control"
                              defaultValue={rNo}
                              disabled={true}
                            />
                          </div>
                        </Col>
                        <Col md={6}>
                          <div className="mb-3">
                            <label>Payee Type</label>
                            <select
                              className="form-select"
                              value={payeeType}
                              onChange={e => updatePayeeType(e)}
                              disabled={RStatus == "Open" ? false : true}
                            >
                              <option value=" ">Select</option>
                              <option value="Staff">Staff</option>
                              <option value="Vendor">Vendor</option>
                              <option value="Subgrantee">Subgrantee</option>
                              <option value="Statutory Bodies">
                                Statutory Bodies
                              </option>
                              <option value="OVC">OVC</option>
                              <option value="Participants">Participants</option>
                              <option value="Bank Transfers">
                                Bank Transfers
                              </option>
                              <option value="Salary Advance">
                                Salary Advance
                              </option>
                            </select>
                          </div>
                        </Col>
                        {(payeeType == "Staff" ||
                          payeeType == "Vendor" ||
                          payeeType == "Subgrantee" ||
                          payeeType == "Statutory Bodies" ||
                          payeeType == "OVC" ||
                          payeeType == "Participants" ||
                          payeeType == "Bank Transfers" ||
                          payeeType == "Salary Advance") && (
                          <Col md={6}>
                            <div className="mb-3">
                              <label>Transaction Type</label>
                              <div className="form-floating mb-3">
                                <select
                                  className="form-select"
                                  value={selectedNo}
                                  onChange={e => updateTransactionType(e)}
                                  disabled={RStatus == "Open" ? false : true}
                                >
                                  <option value="">Select</option>
                                  {transactionTypeslist.map((l, k) => (
                                    <option key={k} value={l.no}>
                                      {l.description}
                                    </option>
                                  ))}
                                </select>
                              </div>
                            </div>
                          </Col>
                        )}
                        {(payeeType == "Staff" ||
                          payeeType == "Vendor" ||
                          payeeType == "Subgrantee" ||
                          payeeType == "Statutory Bodies" ||
                          payeeType == "OVC" ||
                          payeeType == "Participants" ||
                          payeeType == "Bank Transfers" ||
                          payeeType == "Salary Advance") &&
                          (selectedNo == "SALARIES" ||
                            selectedNo != "SPECIALISTS") &&
                          RStatus == "Open" && (
                            <Col md={6}>
                              <div className="mb-3">
                                <label>Select Payee</label>
                                <div className="form-floating mb-3">
                                  <Select
                                    options={noo1}
                                    value={noo1.find(
                                      option => option.value === selectedNo2
                                    )}
                                    onChange={p => handleSelectedPayee(p)}
                                    disabled={RStatus == "Open" ? false : true}
                                  />
                                </div>
                              </div>
                            </Col>
                          )}
                        {RStatus == "Open" && (
                          <Col md={6}>
                            <div className="mb-3">
                              <label>Payee No.</label>
                              <input
                                type="text"
                                className="form-control"
                                defaultValue={selectedNo2}
                                disabled={
                                  RStatus == "Open" &&
                                  (selectedNo != "SALARIES" ||
                                    selectedNo != "SPECIALISTS")
                                    ? true
                                    : false
                                }
                              />
                            </div>
                          </Col>
                        )}
                        {RStatus == "Open" && (
                          <Col md={6}>
                            <div className="mb-3">
                              <label>Payee Name</label>
                              <input
                                type="text"
                                className="form-control"
                                value={payeeName}
                                onChange={e => setPayeeName(e.target.value)}
                                disabled={
                                  RStatus == "Open" &&
                                  selectedNo != "SALARIES" &&
                                  selectedNo != "SPECIALISTS"
                                    ? true
                                    : false
                                }
                              />
                            </div>
                          </Col>
                        )}
                        {RStatus != "Open" && (
                          <Col md={6}>
                            <div className="mb-3">
                              <label>Payee No.</label>
                              <input
                                type="text"
                                className="form-control"
                                defaultValue={selectedNo2}
                                disabled={true}
                              />
                            </div>
                          </Col>
                        )}
                        {RStatus != "Open" && (
                          <Col md={6}>
                            <div className="mb-3">
                              <label>Payee Name</label>
                              <input
                                type="text"
                                className="form-control"
                                value={payeeName}
                                onChange={e => setPayeeName(e.target.value)}
                                disabled={true}
                              />
                            </div>
                          </Col>
                        )}
                        <Col md={6}>
                          <div className="mb-3">
                            <label>Work Plan No.</label>
                            <select
                              className="form-select"
                              value={workplanno}
                              onChange={e => handleChangeWorkPlanNo(e)}
                              disabled={RStatus == "Open" ? false : true}
                            >
                              <option value="">Select</option>
                              {workplans.map((l, k) => (
                                <option key={k} value={l.no}>
                                  {l.no}
                                </option>
                              ))}
                            </select>
                          </div>
                        </Col>

                        <Col md={6}>
                          <div className="mb-3">
                            <label>External Document No.</label>
                            <input
                              type="text"
                              className="form-control"
                              value={externalDocumentNo}
                              onChange={e =>
                                setExternalDocumentNo(e.target.value)
                              }
                              onBlur={updateexternalDocumentNo}
                              disabled={RStatus == "Open" ? false : true}
                            />
                          </div>
                        </Col>
                        {RStatus == "Open" && (
                          <Col md={6}>
                            <div className="mb-3">
                              <label>Activity Start Date</label>
                              {
                                <Flatpickr
                                  className="form-control"
                                  value={activityStartDate}
                                  onChange={e =>
                                    updateActivityStartDate(formatDate(e))
                                  }
                                  options={{
                                    altInput: true,
                                    altFormat: "F j, Y",
                                    dateFormat: "Y-m-d",
                                  }}
                                />
                              }
                            </div>
                          </Col>
                        )}
                        {RStatus == "Open" && (
                          <Col md={6}>
                            <div className="mb-3">
                              <label>Activity End Date</label>
                              {
                                <Flatpickr
                                  className="form-control"
                                  value={activityEndDate}
                                  onChange={e =>
                                    updateActivityEndDate(formatDate(e))
                                  }
                                  options={{
                                    altInput: true,
                                    altFormat: "F j, Y",
                                    dateFormat: "Y-m-d",
                                  }}
                                />
                              }
                            </div>
                          </Col>
                        )}
                        {RStatus != "Open" && (
                          <Col md={6}>
                            <div className="mb-3">
                              <label>Activity Start Date</label>
                              {
                                <Flatpickr
                                  className="form-control"
                                  value={activityStartDate}
                                  onChange={e =>
                                    updateActivityStartDate(formatDate(e))
                                  }
                                  disabled={true}
                                  options={{
                                    altInput: true,
                                    altFormat: "F j, Y",
                                    dateFormat: "Y-m-d",
                                  }}
                                />
                              }
                            </div>
                          </Col>
                        )}
                        {RStatus != "Open" && (
                          <Col md={6}>
                            <div className="mb-3">
                              <label>Activity End Date</label>
                              {
                                <Flatpickr
                                  className="form-control"
                                  value={activityEndDate}
                                  onChange={e =>
                                    updateActivityEndDate(formatDate(e))
                                  }
                                  disabled={true}
                                  options={{
                                    altInput: true,
                                    altFormat: "F j, Y",
                                    dateFormat: "Y-m-d",
                                  }}
                                />
                              }
                            </div>
                          </Col>
                        )}
                        <Col md={6}>
                          <div className="mb-3">
                            <label>Currency Code</label>
                            <select
                              className="form-select"
                              value={currencyCode}
                              onChange={e => updatecurrencyCode(e)}
                              disabled={RStatus == "Open" ? false : true}
                            >
                              <option value="">Select</option>
                              {currencyList.map((l, k) => (
                                <option key={k} value={l.code}>
                                  {l.code}
                                </option>
                              ))}
                            </select>
                          </div>
                        </Col>
                        <Col md={12}>
                          <div className="mb-3">
                            <label>Purpose</label>
                            <textarea
                              type="text"
                              className="form-control"
                              rows={2}
                              value={purpose}
                              onChange={e => setPurpose(e.target.value)}
                              onBlur={updatePurpose}
                              disabled={RStatus == "Open" ? false : true}
                            />
                          </div>
                        </Col>
                        {RStatus == "Pending Approval" &&
                          requisitionerNo == employeeNo1 && (
                            <Col md={12}>
                              <div className="mb-3">
                                <label>Cancellation Comment</label>
                                <textarea
                                  type="text"
                                  className="form-control"
                                  rows={2}
                                  value={cancellationcomment}
                                  onChange={e =>
                                    setCancellationComment(e.target.value)
                                  }
                                  //onBlur={updatePurpose}
                                />
                              </div>
                            </Col>
                          )}
                      </Row>
                    </CardBody>
                  </Card>
                </Col>
                <Col lg={12}>
                  <Card>
                    <CardBody>
                      <CardTitle>
                        <Row className="mb-2">
                          <Col sm={6}>
                            Payment Lines and Costing (
                            {paymentRequisitionLines.length})
                          </Col>

                          {RStatus == "Open" &&
                            payeeType == "Vendor" &&
                            selectedNo != "" &&
                            selectedNo2 != "" &&
                            paymentRequisitionLines.length < 1 && (
                              <Col sm={6}>
                                <div className="text-sm-end">
                                  <Button
                                    color="primary"
                                    className="btn btn-primary btn-label waves-effect waves-light"
                                    onClick={() => {
                                      handleAddLine()
                                    }}
                                  >
                                    <i className="mdi mdi-cash-refund" /> Add
                                    Payment Requisition Line
                                  </Button>
                                </div>
                              </Col>
                            )}
                          {RStatus == "Open" &&
                            payeeType == "Staff" &&
                            selectedNo != "" &&
                            selectedNo2 != "" &&
                            workplanno != "" && (
                              <Col sm={6}>
                                <div className="text-sm-end">
                                  <Button
                                    color="primary"
                                    className="btn btn-primary btn-label waves-effect waves-light"
                                    onClick={() => {
                                      handleAddLine()
                                    }}
                                  >
                                    <i className="mdi mdi-cash-refund" /> Add
                                    Payment Requisition Line
                                  </Button>
                                </div>
                              </Col>
                            )}
                          {RStatus == "Open" &&
                            payeeType == "Staff" &&
                            (selectedNo == "SALARIES" ||
                              selectedNo == "SPECIALISTS") && (
                              <Col sm={6}>
                                <div className="text-sm-end">
                                  <Button
                                    color="primary"
                                    className="btn btn-primary btn-label waves-effect waves-light"
                                    onClick={() => {
                                      handleAddLine()
                                    }}
                                  >
                                    <i className="mdi mdi-cash-refund" /> Add
                                    Payment Requisition Line
                                  </Button>
                                </div>
                              </Col>
                            )}
                          {RStatus == "Open" &&
                            payeeType == "Subgrantee" &&
                            workplanno != "" &&
                            selectedNo != "" &&
                            selectedNo2 != "" && (
                              <Col sm={6}>
                                <div className="text-sm-end">
                                  <Button
                                    color="primary"
                                    className="btn btn-primary btn-label waves-effect waves-light"
                                    onClick={() => {
                                      handleAddLine()
                                    }}
                                  >
                                    <i className="mdi mdi-cash-refund" /> Add
                                    Payment Requisition Line
                                  </Button>
                                </div>
                              </Col>
                            )}
                          {RStatus == "Open" &&
                            payeeType == "Statutory Bodies" &&
                            selectedNo != "" && (
                              <Col sm={6}>
                                <div className="text-sm-end">
                                  <Button
                                    color="primary"
                                    className="btn btn-primary btn-label waves-effect waves-light"
                                    onClick={() => {
                                      handleAddLine()
                                    }}
                                  >
                                    <i className="mdi mdi-cash-refund" /> Add
                                    Payment Requisition Line
                                  </Button>
                                </div>
                              </Col>
                            )}
                          {RStatus == "Open" &&
                            payeeType == "OVC" &&
                            selectedNo != "" &&
                            workplanno != "" && (
                              <Col sm={6}>
                                <div className="text-sm-end">
                                  <Button
                                    color="primary"
                                    className="btn btn-primary btn-label waves-effect waves-light"
                                    onClick={() => {
                                      handleAddLine()
                                    }}
                                  >
                                    <i className="mdi mdi-cash-refund" /> Add
                                    Payment Requisition Line
                                  </Button>
                                </div>
                              </Col>
                            )}
                          {RStatus == "Open" &&
                            payeeType == "Participants" &&
                            selectedNo != "" &&
                            workplanno != "" && (
                              <Col sm={6}>
                                <div className="text-sm-end">
                                  <Button
                                    color="primary"
                                    className="btn btn-primary btn-label waves-effect waves-light"
                                    onClick={() => {
                                      handleAddLine()
                                    }}
                                  >
                                    <i className="mdi mdi-cash-refund" /> Add
                                    Payment Requisition Line
                                  </Button>
                                </div>
                              </Col>
                            )}
                          {RStatus == "Open" &&
                            payeeType == "Bank Transfers" &&
                            selectedNo != "" &&
                            selectedNo2 != "" && (
                              <Col sm={6}>
                                <div className="text-sm-end">
                                  <Button
                                    color="primary"
                                    className="btn btn-primary btn-label waves-effect waves-light"
                                    onClick={() => {
                                      handleAddLine()
                                    }}
                                  >
                                    <i className="mdi mdi-cash-refund" /> Add
                                    Payment Requisition Line
                                  </Button>
                                </div>
                              </Col>
                            )}
                          {RStatus == "Open" &&
                            payeeType == "Salary Advance" &&
                            selectedNo != "" &&
                            selectedNo2 != "" &&
                            workplanno != "" && (
                              <Col sm={6}>
                                <div className="text-sm-end">
                                  <Button
                                    color="primary"
                                    className="btn btn-primary btn-label waves-effect waves-light"
                                    onClick={() => {
                                      handleAddLine()
                                    }}
                                  >
                                    <i className="mdi mdi-cash-refund" /> Add
                                    Payment Requisition Line
                                  </Button>
                                </div>
                              </Col>
                            )}
                          {RStatus == "Open" &&
                            payeeType == "Staff" &&
                            selectedNo == "DIRECT" && (
                              <Col sm={6}>
                                <div className="text-sm-end">
                                  <Button
                                    color="primary"
                                    className="btn btn-primary btn-label waves-effect waves-light"
                                    onClick={() => {
                                      handleAddLine()
                                    }}
                                  >
                                    <i className="mdi mdi-cash-refund" /> Add
                                    Payment Requisition Line
                                  </Button>
                                </div>
                              </Col>
                            )}
                        </Row>
                      </CardTitle>
                      {paymentRequisitionLines.length > 0 ? (
                        <div className="table-responsive">
                          <Table className="table table-striped table-sm mb-4">
                            <thead>
                              <tr>
                                <th>Account Type</th>
                                <th>Account No</th>
                                <th>Work Plan Entry No</th>
                                <th>Account Name</th>
                                <th>Qty</th>
                                <th>Rate</th>
                                <th>Amount</th>
                                <th>Amount to Pay</th>
                                <th>Action</th>
                                <th></th>
                              </tr>
                            </thead>
                            <tbody>
                              {paymentRequisitionLines.map((a, k) => (
                                <tr key={k}>
                                  <td>{a.accountType}</td>
                                  <td>{a.accountNo}</td>
                                  <td>{a.workPlanEntryNo}</td>
                                  <td>{a.accountName}</td>
                                  <td
                                    style={{
                                      verticalAlign: "middle",
                                      textAlign: "center",
                                    }}
                                  >
                                    {a.quantity}
                                  </td>
                                  <td
                                    style={{
                                      verticalAlign: "middle",
                                      textAlign: "center",
                                    }}
                                  >
                                    {a.rate}
                                  </td>
                                  <td
                                    style={{
                                      verticalAlign: "middle",
                                      textAlign: "center",
                                    }}
                                  >
                                    {a.amount}
                                  </td>
                                  <td
                                    style={{
                                      verticalAlign: "middle",
                                      textAlign: "center",
                                    }}
                                  >
                                    {a.amountToPay}
                                  </td>
                                  <td>
                                    {" "}
                                    <>
                                      {/* {(RStatus == 'Open') && ( */}
                                      {rNo != "" && (
                                        <div className="d-flex gap-3">
                                          <Link
                                            to="#"
                                            className="text-success"
                                            onClick={() =>
                                              handleClickLineDetails(k)
                                            }
                                          >
                                            <i
                                              className="mdi mdi-pencil font-size-18"
                                              id="edittooltip"
                                            />
                                            <UncontrolledTooltip
                                              placement="top"
                                              target="edittooltip"
                                            >
                                              Edit
                                            </UncontrolledTooltip>
                                          </Link>
                                        </div>
                                      )}
                                    </>
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </Table>
                        </div>
                      ) : (
                        <div className="text-center">
                          <div className="mb-4">
                            <i className="mdi mdi-cash-refund text-warning display-4" />
                          </div>
                          <div>
                            <h5>No payment requisition lines found!</h5>
                            <p className="text-muted"></p>
                          </div>
                        </div>
                      )}
                    </CardBody>
                  </Card>
                </Col>

                <Col>
                  <Modal
                    isOpen={modal_line}
                    toggle={() => {
                      tog_line()
                    }}
                    size="xl"
                    centered
                    backdrop={"static"}
                  >
                    <div className="modal-header">
                      <h5 className="modal-title mt-0" id="myModalLabel">
                        {isEdit ? `Update/Delete ` : `Add `}Payment Requisition
                        Line
                      </h5>
                      <button
                        type="button"
                        onClick={() => {
                          setmodal_line(false)
                        }}
                        className="close"
                        data-dismiss="modal"
                        aria-label="Close"
                      >
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                    <div className="modal-body">
                      <Row>
                        {payeeType == "Vendor" && (
                          <Col lg={6}>
                            <div className="mb-3">
                              <label>Account Type</label>
                              <select
                                className="form-select"
                                value={accountType}
                                onChange={e => {
                                  handleAccountTypeChange(e)
                                }}
                                disabled={RStatus == "Open" ? false : true}
                              >
                                <option value=" ">Select</option>
                                <option value="Vendor">Vendor</option>
                              </select>
                            </div>
                          </Col>
                        )}
                        {payeeType == "Staff" &&
                          (selectedNo == "BUSINESS ADVANCE" ||
                            selectedNo == "PERDIEM" ||
                            selectedNo == "PREPAID EXPENSE" ||
                            selectedNo == "REFUNDS" ||
                            selectedNo == "VOLUNTEER") && (
                            <Col lg={4}>
                              <div className="mb-3">
                                <label>Account Type</label>
                                <select
                                  className="form-select"
                                  value={accountType}
                                  onChange={e => {
                                    handleAccountTypeChange2(e)
                                  }}
                                  disabled={RStatus == "Open" ? false : true}
                                >
                                  <option value=" ">Select</option>
                                  <option value="G/L Account">
                                    G/L Account
                                  </option>
                                </select>
                              </div>
                            </Col>
                          )}
                        {payeeType == "OVC" && workplanno != "" && (
                          <Col lg={4}>
                            <div className="mb-3">
                              <label>Account Type</label>
                              <select
                                className="form-select"
                                value={accountType}
                                onChange={e => {
                                  handleAccountTypeChange2(e)
                                }}
                                disabled={RStatus == "Open" ? false : true}
                              >
                                <option value=" ">Select</option>
                                <option value="G/L Account">G/L Account</option>
                              </select>
                            </div>
                          </Col>
                        )}
                        {payeeType == "Salary Advance" &&
                          workplanno != "" &&
                          selectedNo != "" && (
                            <Col lg={4}>
                              <div className="mb-3">
                                <label>Account Type</label>
                                <select
                                  className="form-select"
                                  value={accountType}
                                  onChange={e => {
                                    handleAccountTypeChange2(e)
                                  }}
                                  disabled={RStatus == "Open" ? false : true}
                                >
                                  <option value=" ">Select</option>
                                  <option value="G/L Account">
                                    G/L Account
                                  </option>
                                </select>
                              </div>
                            </Col>
                          )}
                        {payeeType == "Participants" && workplanno != "" && (
                          <Col lg={4}>
                            <div className="mb-3">
                              <label>Account Type</label>
                              <select
                                className="form-select"
                                value={accountType}
                                onChange={e => {
                                  handleAccountTypeChange2(e)
                                }}
                                disabled={RStatus == "Open" ? false : true}
                              >
                                <option value=" ">Select</option>
                                <option value="G/L Account">G/L Account</option>
                              </select>
                            </div>
                          </Col>
                        )}
                        {payeeType == "Staff" &&
                          (selectedNo == "SALARIES" ||
                            selectedNo == "SPECIALISTS") && (
                            <Col lg={4}>
                              <div className="mb-3">
                                <label>Account Type</label>
                                <select
                                  className="form-select"
                                  value={accountType}
                                  onChange={e => {
                                    handleAccountTypeChange3(e)
                                  }}
                                  disabled={RStatus == "Open" ? false : true}
                                >
                                  <option value=" ">Select</option>
                                  <option value="None Workplan- G/L">
                                    None Workplan- G/L
                                  </option>
                                </select>
                              </div>
                            </Col>
                          )}
                        {payeeType == "Statutory Bodies" &&
                          selectedNo != "" && (
                            <Col lg={4}>
                              <div className="mb-3">
                                <label>Account Type</label>
                                <select
                                  className="form-select"
                                  value={accountType}
                                  onChange={e => {
                                    handleAccountTypeChange3(e)
                                  }}
                                  disabled={RStatus == "Open" ? false : true}
                                >
                                  <option value=" ">Select</option>
                                  <option value="None Workplan- G/L">
                                    None Workplan- G/L
                                  </option>
                                </select>
                              </div>
                            </Col>
                          )}
                        {payeeType == "Subgrantee" &&
                          selectedNo != "" &&
                          workplanno != "" &&
                          selectedNo2 != "" && (
                            <Col lg={4}>
                              <div className="mb-3">
                                <label>Account Type</label>
                                <select
                                  className="form-select"
                                  value={accountType}
                                  onChange={e => {
                                    handleAccountTypeChange4(e)
                                  }}
                                  disabled={RStatus == "Open" ? false : true}
                                >
                                  <option value=" ">Select</option>
                                  <option value="Customer">Customer</option>
                                  <option value="G/L Account">
                                    G/L Account
                                  </option>
                                  <option value="None Workplan- G/L">
                                    None Workplan- G/L
                                  </option>
                                  <option value="Bank Account">
                                    Bank Account
                                  </option>
                                </select>
                              </div>
                            </Col>
                          )}
                        {payeeType == "Staff" && selectedNo != "" && (
                          <Col lg={4}>
                            <div className="mb-3">
                              <label>Account Type</label>
                              <select
                                className="form-select"
                                value={accountType}
                                onChange={e => {
                                  handleAccountTypeChange4(e)
                                }}
                                disabled={RStatus == "Open" ? false : true}
                              >
                                <option value=" ">Select</option>
                                <option value="G/L Account">G/L Account</option>
                                <option value="None Workplan- G/L">
                                  None Workplan- G/L
                                </option>
                                <option value="Bank Account">
                                  Bank Account
                                </option>
                              </select>
                            </div>
                          </Col>
                        )}
                        {payeeType == "Bank Transfers" &&
                          selectedNo != "" &&
                          selectedNo2 != "" && (
                            <Col lg={4}>
                              <div className="mb-3">
                                <label>Account Type</label>
                                <select
                                  className="form-select"
                                  value={accountType}
                                  onChange={e => {
                                    handleAccountTypeChange5(e)
                                  }}
                                  disabled={RStatus == "Open" ? false : true}
                                >
                                  <option value=" ">Select</option>
                                  <option value="Bank Account">
                                    Bank Account
                                  </option>
                                </select>
                              </div>
                            </Col>
                          )}
                        {RStatus == "Open" &&
                          payeeType == "Staff" &&
                          (accountType != "" || accountType != " ") &&
                          (selectedNo == "BUSINESS ADVANCE" ||
                            selectedNo == "PERDIEM" ||
                            selectedNo == "PREPAID EXPENSE" ||
                            selectedNo == "REFUNDS" ||
                            selectedNo == "VOLUNTEER" ||
                            selectedNo == "SALARIES" ||
                            selectedNo == "SPECIALISTS") && (
                            <Col lg={4}>
                              <label htmlFor="floatingSelectGrid">
                                Account Name
                              </label>
                              <div
                                className="form-floating mb-3"
                                disabled={RStatus == "Open" ? false : true}
                              >
                                <Select
                                  options={noo}
                                  value={noo.find(
                                    option => option.value === accountNo
                                  )}
                                  onChange={handleNoChange}
                                />
                              </div>
                            </Col>
                          )}
                        {RStatus == "Open" && payeeType == "Bank Transfers" && (
                          <Col lg={4}>
                            <label htmlFor="floatingSelectGrid">
                              Account Name
                            </label>
                            <div className="form-floating mb-3">
                              <Select
                                options={noo}
                                value={noo.find(
                                  option => option.value === accountNo
                                )}
                                onChange={handleNoChange}
                              />
                            </div>
                          </Col>
                        )}
                        {RStatus == "Open" && payeeType == "Salary Advance" && (
                          <Col lg={4}>
                            <label htmlFor="floatingSelectGrid">
                              Account Name
                            </label>
                            <div className="form-floating mb-3">
                              <Select
                                options={noo}
                                value={noo.find(
                                  option => option.value === accountNo
                                )}
                                onChange={handleNoChange}
                              />
                            </div>
                          </Col>
                        )}
                        {RStatus == "Open" && payeeType == "Subgrantee" && (
                          <Col lg={4}>
                            <label htmlFor="floatingSelectGrid">
                              Account Name
                            </label>
                            <div className="form-floating mb-3">
                              <Select
                                options={noo}
                                value={noo.find(
                                  option => option.value === accountNo
                                )}
                                onChange={handleNoChange}
                              />
                            </div>
                          </Col>
                        )}
                        {RStatus == "Open" &&
                          payeeType == "Staff" &&
                          selectedNo == "DIRECT" && (
                            <Col lg={4}>
                              <label htmlFor="floatingSelectGrid">
                                Account Name
                              </label>
                              <div className="form-floating mb-3">
                                <Select
                                  options={noo}
                                  value={noo.find(
                                    option => option.value === accountNo
                                  )}
                                  onChange={handleNoChange}
                                />
                              </div>
                            </Col>
                          )}
                        {RStatus == "Open" && payeeType == "OVC" && (
                          <Col lg={4}>
                            <label htmlFor="floatingSelectGrid">
                              Account Name
                            </label>
                            <div className="form-floating mb-3">
                              <Select
                                options={noo}
                                value={noo.find(
                                  option => option.value === accountNo
                                )}
                                onChange={handleNoChange}
                              />
                            </div>
                          </Col>
                        )}
                        {RStatus == "Open" && payeeType == "Participants" && (
                          <Col lg={4}>
                            <label htmlFor="floatingSelectGrid">
                              Account Name
                            </label>
                            <div className="form-floating mb-3">
                              <Select
                                options={noo}
                                value={noo.find(
                                  option => option.value === accountNo
                                )}
                                onChange={handleNoChange}
                              />
                            </div>
                          </Col>
                        )}
                        {RStatus == "Open" &&
                          payeeType == "Statutory Bodies" && (
                            <Col lg={4}>
                              <label htmlFor="floatingSelectGrid">
                                Account Name
                              </label>
                              <div className="form-floating mb-3">
                                <Select
                                  options={noo}
                                  value={noo.find(
                                    option => option.value === accountNo
                                  )}
                                  onChange={handleNoChange}
                                />
                              </div>
                            </Col>
                          )}
                        {accountType == "Vendor" && (
                          <Col lg={6}>
                            <div className="mb-3">
                              <label>Account No </label>
                              <input
                                className="form-control"
                                value={accountNo}
                                disabled={true}
                              />
                            </div>
                          </Col>
                        )}
                        {RStatus == "Open" && accountType == "Vendor" && (
                          <Col lg={12}>
                            <div className="mb-3">
                              <label>Account Name </label>
                              <input
                                className="form-control"
                                value={accountName}
                                disabled={true}
                              />
                            </div>
                          </Col>
                        )}
                        {RStatus != "Open" && accountType == "Vendor" && (
                          <Col lg={12}>
                            <div className="mb-3">
                              <label>Account Name </label>
                              <input
                                className="form-control"
                                value={accountName}
                                disabled={true}
                              />
                            </div>
                          </Col>
                        )}
                        {RStatus != "Open" && (
                          <Col lg={4}>
                            <div className="mb-3">
                              <label>Account Name </label>
                              <input
                                className="form-control"
                                value={accountName}
                                disabled={true}
                              />
                            </div>
                          </Col>
                        )}
                        {accountType != "Vendor" && (
                          <Col lg={4}>
                            <div className="mb-3">
                              <label>Account No. </label>
                              <input
                                className="form-control"
                                value={accountNo}
                                disabled={true}
                              />
                            </div>
                          </Col>
                        )}
                        {accountType != "Vendor" && (
                          <Col lg={4} className="mb-3">
                            <label htmlFor="floatingSelectGrid">
                              Workplan Entry No
                            </label>
                            <select
                              className="form-select"
                              value={workPlanEntryNo}
                              onChange={e => setWorkPlanEntryNo(e.target.value)}
                              disabled={RStatus == "Open" ? false : true}
                            >
                              <option value="">Select</option>
                              {workPlanEntry.map((l, k) => (
                                <option key={k} value={l.entryNo}>
                                  {l.entryNo}
                                </option>
                              ))}
                            </select>
                          </Col>
                        )}
                        {accountType != "Vendor" && (
                          <Col lg={8}>
                            <label htmlFor="floatingSelectGrid">
                              Narration
                            </label>
                            <div className="mb-3">
                              <input
                                type="text"
                                className="form-control"
                                value={narration}
                                onChange={e => setNarration(e.target.value)}
                                disabled={RStatus == "Open" ? false : true}
                              />
                            </div>
                          </Col>
                        )}
                        {accountType == "Vendor" && (
                          <Col lg={12}>
                            <label htmlFor="floatingSelectGrid">
                              Narration
                            </label>
                            <div className="mb-3">
                              <input
                                type="text"
                                className="form-control"
                                value={narration}
                                onChange={e => setNarration(e.target.value)}
                                disabled={RStatus == "Open" ? false : true}
                              />
                            </div>
                          </Col>
                        )}
                        <Col lg={3}>
                          <label htmlFor="floatingSelectGrid">Quantity</label>
                          <div className="mb-3">
                            <input
                              type="number"
                              className="form-control"
                              value={quantity}
                              onChange={e => {
                                setQuantity(e.target.value)
                              }}
                              disabled={RStatus == "Open" ? false : true}
                            />
                          </div>
                        </Col>
                        <Col lg={3}>
                          <label htmlFor="floatingSelectGrid">Rate</label>
                          <div className="mb-3">
                            <input
                              type="number"
                              className="form-control"
                              value={rate}
                              onChange={e => {
                                setRate(e.target.value)
                              }}
                              disabled={RStatus == "Open" ? false : true}
                            />
                          </div>
                        </Col>
                        <Col lg={3}>
                          <label htmlFor="floatingSelectGrid">Amount</label>
                          <div className="mb-3">
                            <input
                              type="number"
                              className="form-control"
                              value={amount}
                              disabled={true}
                            />
                          </div>
                        </Col>
                        <Col lg={3}>
                          <label htmlFor="floatingSelectGrid">Amount LCY</label>
                          <div className="mb-3">
                            <input
                              type="number"
                              className="form-control"
                              value={amountLCY}
                              disabled={true}
                            />
                          </div>
                        </Col>
                        <Col lg={3}>
                          <label htmlFor="floatingSelectGrid">
                            WHT Percentage
                          </label>
                          <div className="mb-3">
                            <input
                              type="number"
                              className="form-control"
                              value={whtpercentage}
                              onChange={e => {
                                setWHTPercentage(e.target.value)
                              }}
                              disabled={true}
                            />
                          </div>
                        </Col>
                        <Col lg={3}>
                          <label htmlFor="floatingSelectGrid">WHT Amount</label>
                          <div className="mb-3">
                            <input
                              type="number"
                              className="form-control"
                              value={whtamount}
                              onChange={e => {
                                setWHTAmount(e.target.value)
                              }}
                              disabled={RStatus == "Open" ? false : true}
                            />
                          </div>
                        </Col>
                        <Col lg={3}>
                          <label htmlFor="floatingSelectGrid">
                            WHT Amount on VAT
                          </label>
                          <div className="mb-3">
                            <input
                              type="number"
                              className="form-control"
                              value={whtAmountOnVAT}
                              onChange={e => {
                                setWHTAmountonVAT(e.target.value)
                              }}
                              disabled={RStatus == "Open" ? false : true}
                            />
                          </div>
                        </Col>
                        <Col lg={3}>
                          <label htmlFor="floatingSelectGrid">VAT Amount</label>
                          <div className="mb-3">
                            <input
                              type="number"
                              className="form-control"
                              value={vatAmount}
                              onChange={e => {
                                setVATAmount(e.target.value)
                              }}
                              disabled={true}
                            />
                          </div>
                        </Col>
                        <Col lg={3}>
                          <label htmlFor="floatingSelectGrid">
                            Amount to Pay
                          </label>
                          <div className="mb-3">
                            <input
                              type="number"
                              className="form-control"
                              value={amountToPay}
                              onChange={e => {
                                setAmounttoPay(e.target.value)
                              }}
                              disabled={RStatus == "Open" ? false : true}
                            />
                          </div>
                        </Col>
                        <Col lg={3}>
                          <label htmlFor="floatingSelectGrid">
                            Amount Paid
                          </label>
                          <div className="mb-3">
                            <input
                              type="number"
                              className="form-control"
                              value={amountPaid}
                              onChange={e => {
                                setAmountPaid(e.target.value)
                              }}
                              disabled={true}
                            />
                          </div>
                        </Col>
                        <Col lg={3}>
                          <label htmlFor="floatingSelectGrid">
                            No. of Installments
                          </label>
                          <div className="mb-3">
                            <input
                              type="number"
                              className="form-control"
                              value={noOfInstallments}
                              onChange={e => {
                                setNoofInstallments(e.target.value)
                              }}
                              disabled={true}
                            />
                          </div>
                        </Col>
                        <Col lg={3}>
                          <label htmlFor="floatingSelectGrid">
                            Installment Amount
                          </label>
                          <div className="mb-3">
                            <input
                              type="number"
                              className="form-control"
                              value={installmentAmount}
                              onChange={e => {
                                setInstallmentAmount(e.target.value)
                              }}
                              disabled={true}
                            />
                          </div>
                        </Col>
                        {/* <Col lg={3}>
                                                <label htmlFor="floatingSelectGrid">Fund Source</label>
                                                <div className="mb-3">
                                                    <Select options={fundsourceDim} 
                                                        value={fundsourceDim.find((option) => option.value === fundsource)} 
                                                        onChange={handleFundsourcechange} 
                                                    />
                                                </div>
                                            </Col> */}
                      </Row>
                    </div>
                    <div className="modal-footer">
                      <div className="hstack gap-2 mb-0">
                        {payeeType == "Vendor" && (
                          <Button
                            color="info"
                            type="button"
                            className="btn btnSubmitPlan"
                            onClick={() => {
                              tog_applyEntries()
                            }}
                          >
                            <i className="mdi mdi-cash-refund" /> Apply Entries
                          </Button>
                        )}
                        {isEdit && RStatus == "Open" && (
                          <Button
                            color="success"
                            type="button"
                            className="btn btnSubmitPlan"
                            onClick={handleUpdateLine}
                          >
                            <i className="mdi mdi-book-outline" /> Update Line
                          </Button>
                        )}
                        {!isEdit && RStatus == "Open" && (
                          <Button
                            color="success"
                            type="button"
                            className="btn btnSubmitPlan"
                            onClick={handleAddLine2}
                          >
                            <i className="mdi mdi-save" /> Save Line details...
                          </Button>
                        )}
                        {RStatus == "Open" && (
                          <Button
                            color="danger"
                            type="button"
                            className="btn btnSubmitPlan"
                            onClick={() => {
                              handleDeleteLine2()
                            }}
                          >
                            <i className="mdi mdi-delete" /> Delete line
                          </Button>
                        )}
                      </div>
                    </div>
                  </Modal>

                  <Modal
                    isOpen={modal_attachments}
                    toggle={() => {
                      tog_attachments()
                    }}
                    size="l"
                    centered
                    backdrop={"static"}
                  >
                    <div className="modal-header">
                      <h5
                        className="modal-title mt-0"
                        id="myModalLabel"
                      >{`Files`}</h5>
                      <button
                        type="button"
                        onClick={() => {
                          setmodal_attachments(false)
                        }}
                        className="close"
                        data-dismiss="modal"
                        aria-label="Close"
                      >
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                    <div className="modal-body">
                      <Row>
                        <Col xl={12}>
                          <div className="mb-3">
                            <label htmlFor="floatingnameInput">
                              Attach Files
                            </label>
                            <input
                              type="file"
                              multiple
                              className="form-control"
                              onChange={e => handleSelectedFiles(e)}
                            />
                          </div>
                        </Col>
                      </Row>
                    </div>
                    <div className="modal-footer">
                      <button
                        onClick={() => {
                          tog_attachments()
                        }}
                        className="btn btn-danger"
                        data-dismiss="modal"
                      >
                        Cancel
                      </button>
                      <button
                        className="btn btn-success"
                        onClick={handleSaveFiles}
                      >
                        Add file(s)...
                      </button>
                    </div>
                  </Modal>

                  <Modal
                    isOpen={modal_applyEntries}
                    toggle={() => {
                      tog_applyEntries()
                    }}
                    size="xl"
                    centered
                    backdrop={"static"}
                  >
                    <div className="modal-header">
                      <h5 className="modal-title mt-0" id="myModalLabel">
                        Apply Vendor Entries - {payeeNo} · {payeeName}
                      </h5>
                      <button
                        type="button"
                        onClick={() => {
                          setmodal_applyEntries(false)
                        }}
                        className="close"
                        data-dismiss="modal"
                        aria-label="Close"
                      >
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                    <div className="modal-body">
                      <Row>
                        {RStatus == "Open" && addDetails && (
                          <>
                            <Col lg={3}>
                              <div className="mb-3">
                                <label>Select Entry</label>
                                <select
                                  className="form-select"
                                  value={applyEntry ? "true" : "false"}
                                  onChange={e => updateApplyEntry(e)}
                                  disabled={RStatus == "Open" ? false : true}
                                >
                                  <option value={``}>Select</option>
                                  <option value={true}>Yes</option>
                                  <option value={false}>No</option>
                                </select>
                              </div>
                            </Col>
                            <Col lg={3}>
                              <label>Posting Date</label>
                              <div className="form-floating mb-3">
                                <Flatpickr
                                  className="form-control"
                                  disabled={true}
                                  placeholder="dd M,yyyy"
                                  options={{
                                    altInput: true,
                                    altFormat: "F j, Y",
                                    dateFormat: "Y-m-d",
                                  }}
                                  value={applnPostingDate}
                                />
                              </div>
                            </Col>
                            <Col lg={3}>
                              <label htmlFor="floatingSelectGrid">
                                Document Type
                              </label>
                              <div className="form-floating mb-3">
                                <input
                                  type="text"
                                  className="form-control"
                                  value={applnDocumentType}
                                  disabled={true}
                                />
                              </div>
                            </Col>
                            <Col lg={3}>
                              <label htmlFor="floatingSelectGrid">
                                Document No.
                              </label>
                              <div className="form-floating mb-3">
                                <input
                                  type="text"
                                  className="form-control"
                                  value={applnDocumentNo}
                                  disabled={true}
                                />
                              </div>
                            </Col>
                            <Col lg={3}>
                              <label htmlFor="floatingSelectGrid">
                                External Document No.
                              </label>
                              <div className="form-floating mb-3">
                                <input
                                  type="text"
                                  className="form-control"
                                  value={applnExtDocNo}
                                  disabled={true}
                                />
                              </div>
                            </Col>
                            <Col lg={3}>
                              <label htmlFor="floatingSelectGrid">
                                Currency Code
                              </label>
                              <div className="form-floating mb-3">
                                <input
                                  type="text"
                                  className="form-control"
                                  value={applnCurrencyCode}
                                  disabled={true}
                                />
                              </div>
                            </Col>
                            <Col lg={3}>
                              <label htmlFor="floatingSelectGrid">
                                Remaining Amount
                              </label>
                              <div className="form-floating mb-3">
                                <input
                                  type="text"
                                  className="form-control"
                                  value={remainingAmount}
                                  disabled={true}
                                />
                              </div>
                            </Col>
                            <Col lg={3}>
                              <label htmlFor="floatingSelectGrid">
                                Application Remaining Amount
                              </label>
                              <div className="form-floating mb-3">
                                <input
                                  type="text"
                                  className="form-control"
                                  value={applnReminingAmount}
                                  disabled={true}
                                />
                              </div>
                            </Col>
                            <Col lg={12}>
                              <label htmlFor="floatingSelectGrid">
                                Description
                              </label>
                              <div className="form-floating mb-3">
                                <input
                                  type="text"
                                  className="form-control"
                                  value={applnDescription}
                                  disabled={true}
                                />
                              </div>
                            </Col>
                          </>
                        )}
                        <Col sm={12}>
                          <h5 className="text-primary">- View details</h5>
                          <hr />
                        </Col>
                        <Col lg={12}>
                          {managementActivities.length > 0 ? (
                            <div className="table-responsive">
                              <Table className="table table-striped table-wrap table-sm mb-4">
                                <thead>
                                  <tr>
                                    <th>Select Entry</th>
                                    <th>Applies-to ID</th>
                                    <th>Posting Date</th>
                                    <th>Document Type</th>
                                    <th
                                      style={{
                                        verticalAlign: "middle",
                                        textAlign: "center",
                                      }}
                                    >
                                      Document No.
                                    </th>
                                    <th
                                      style={{
                                        verticalAlign: "middle",
                                        textAlign: "center",
                                      }}
                                    >
                                      Ext. Document No.
                                    </th>
                                    <th
                                      style={{
                                        verticalAlign: "middle",
                                        textAlign: "center",
                                      }}
                                    >
                                      Description
                                    </th>
                                    <th
                                      style={{
                                        verticalAlign: "middle",
                                        textAlign: "center",
                                      }}
                                    >
                                      Currency
                                    </th>
                                    <th
                                      style={{
                                        verticalAlign: "middle",
                                        textAlign: "center",
                                      }}
                                    >
                                      Remaining Amt
                                    </th>
                                    <th
                                      style={{
                                        verticalAlign: "middle",
                                        textAlign: "center",
                                      }}
                                    >
                                      Application Remaining Amt
                                    </th>
                                    <th
                                      style={{
                                        verticalAlign: "middle",
                                        textAlign: "center",
                                      }}
                                    >
                                      Action
                                    </th>
                                    <th
                                      style={{
                                        verticalAlign: "middle",
                                        textAlign: "center",
                                      }}
                                    ></th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {managementActivities.map((a, k) => (
                                    <tr key={k}>
                                      <td>
                                        {a.applyEntry ? (
                                          <i className="mdi mdi-check"></i>
                                        ) : (
                                          <i className="mdi mdi-close"></i>
                                        )}
                                      </td>
                                      <td>{a.appliesToID}</td>
                                      <td>{a.postingDate}</td>
                                      <td>{a.documentType}</td>
                                      <td
                                        style={{
                                          verticalAlign: "middle",
                                          textAlign: "center",
                                        }}
                                      >
                                        {a.documentNo}
                                      </td>
                                      <td
                                        style={{
                                          verticalAlign: "middle",
                                          textAlign: "center",
                                        }}
                                      >
                                        {a.externalDocNo}
                                      </td>
                                      <td
                                        style={{
                                          verticalAlign: "middle",
                                          textAlign: "center",
                                        }}
                                      >
                                        {a.description}
                                      </td>
                                      <td
                                        style={{
                                          verticalAlign: "middle",
                                          textAlign: "center",
                                        }}
                                      >
                                        {a.curCode}
                                      </td>
                                      <td
                                        style={{
                                          verticalAlign: "middle",
                                          textAlign: "center",
                                        }}
                                      >
                                        {a.remainingAmount}
                                      </td>
                                      <td
                                        style={{
                                          verticalAlign: "middle",
                                          textAlign: "center",
                                        }}
                                      >
                                        {a.applnremainingAmount}
                                      </td>
                                      <td
                                        style={{
                                          verticalAlign: "middle",
                                          textAlign: "center",
                                        }}
                                      >
                                        {" "}
                                        <>
                                          {RStatus == "Open" && (
                                            <div className="d-flex gap-3">
                                              <Link
                                                to="#"
                                                className="text-success"
                                                onClick={() =>
                                                  handleEditManagement(k)
                                                }
                                              >
                                                <i
                                                  className="mdi mdi-pencil font-size-18"
                                                  id="edittooltip"
                                                />
                                                <UncontrolledTooltip
                                                  placement="top"
                                                  target="edittooltip"
                                                >
                                                  Edit
                                                </UncontrolledTooltip>
                                              </Link>
                                            </div>
                                          )}
                                        </>
                                      </td>
                                    </tr>
                                  ))}
                                </tbody>
                              </Table>
                            </div>
                          ) : (
                            <div className="text-center">
                              <div className="mb-4">
                                <i className="mdi mdi-cash-refund text-warning display-4" />
                              </div>
                              <div>
                                <h5>No Vendor Ledger Entries found</h5>
                                <p className="text-muted"></p>
                              </div>
                            </div>
                          )}
                        </Col>
                        <Row className="justify-content-center">
                          {managementActivities.length > 0 && (
                            <>
                              <Col md={6} className="mb-4 mt-3">
                                <div className="d-grid">
                                  <Button
                                    color="primary"
                                    type="button"
                                    className="btn-rounded"
                                    onClick={handleAppliestoID}
                                  >
                                    Set Applies-to ID
                                  </Button>
                                </div>
                              </Col>
                              <Col md={6} className="mb-4 mt-3">
                                <div className="d-grid">
                                  <Button
                                    color="warning"
                                    type="button"
                                    className="btn-rounded"
                                    onClick={handleUnapplyEntries}
                                  >
                                    Un-Apply Entries
                                  </Button>
                                </div>
                              </Col>
                            </>
                          )}
                        </Row>
                      </Row>
                    </div>
                  </Modal>

                  <Modal
                    isOpen={modal_comments}
                    toggle={() => {
                      tog_comments()
                    }}
                    centered
                    size="xl"
                  >
                    <div className="modal-header">
                      <h5 className="modal-title mt-0" id="myModalLabel">
                        Rejection Comments
                      </h5>
                      <button
                        type="button"
                        onClick={() => {
                          setmodal_comments(false)
                        }}
                        className="close"
                        data-dismiss="modal"
                        aria-label="Close"
                      >
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                    <div className="modal-body">
                      <Row>
                        <Col lg={12}>
                          {approvalCommentLines.length > 0 ? (
                            <div className="table-responsive">
                              <Table className="table table-sm m-0">
                                <thead>
                                  <tr>
                                    <th>Document No.</th>
                                    <th>Comment</th>
                                    <th>Rejected by</th>
                                    <th>Rejection Date/Time</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {approvalCommentLines.map((a, k) => (
                                    <tr key={k}>
                                      <td>{a.document_No}</td>
                                      <td>{a.Comment}</td>
                                      <td>{a.rejected_By}</td>
                                      <td>{a.rejected_Date_Time}</td>
                                    </tr>
                                  ))}
                                </tbody>
                              </Table>
                            </div>
                          ) : (
                            <div className="text-center">
                              <div className="mb-4">
                                <i className="mdi mdi-school-outline text-warning display-4" />
                              </div>
                              <div>
                                <h5>No rejection comments found</h5>
                                <p className="text-muted"></p>
                              </div>
                            </div>
                          )}
                        </Col>
                      </Row>
                    </div>
                  </Modal>
                  <br />
                </Col>
              </Row>
            ) : (
              <Row className="d-flex justify-content-center">
                <Col lg={8}>
                  <Card outline color="success" className="border">
                    <CardBody>
                      <CardTitle className="mb-4 text-white"></CardTitle>
                      <CardText></CardText>
                      <div className="text-center">
                        <div className="mb-4">
                          <i className="mdi mdi-check-circle-outline text-success display-4" />
                        </div>
                        <div>
                          <h5>Saved</h5>
                          <p className="text-muted">
                            Requisition <strong>{ipaNo}</strong> Saved!
                          </p>
                        </div>
                      </div>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            )}
          </div>
        </Container>
      </div>
    </LoadingOverlay>
  )
}

export default PaymentRequisitionDetails
